export default {
  // Sidebar
  appTitle: 'Terminus',
  newThesis: 'Nueva Línea de solución',
  addThesis: 'Añadir Línea de solución',
  titlePlaceholder: 'Título de la línea de solución',
  descriptionPlaceholder: 'Breve descripción de tu línea de solución',
  cancel: 'Cancelar',
  add: 'Añadir',
  confirmDelete: 'Confirmar Eliminación',
  deleteThesisQuestion: '¿Estás seguro de que quieres eliminar esta línea de solución?',
  deleteAction: 'Eliminar',
  done: 'listo',
  thesisCreated: 'Nueva Línea de solución Creada',
  thesisAdded: 'Línea de solución Añadida',
  thesisAddedDesc: 'Tu nueva línea de solución ha sido añadida con éxito.',
  
  // Chat
  markDone: 'Marcar refinamiento como completado',
  refinementComplete: 'Refinamiento completado',
  typePlaceholder: 'Introduce feedback para refinar las soluciones...',
  connected: 'Conectado',
  disconnected: 'Desconectado',
  newMessage: 'Nuevo Mensaje',
  generatedSolutions: 'Soluciones Generadas',
  refineSolutions: 'Refinar Soluciones',
  refineShort: 'Refinar',
  refiningSolutions: 'Refinando Soluciones',
  refiningSolutionsDesc: 'Tu feedback está siendo utilizado para refinar las soluciones de investigación.',
  send: 'Enviar',
  regularMessage: 'Mensaje Regular',
  error: 'Error',
  unknownError: 'Ocurrió un error desconocido',
  
  // Status
  status: {
    draft: 'Borrador',
    submitted: 'Enviado',
    in_progress: 'En Progreso',
    running: 'En Ejecución',
    done: 'Completado',
    published: 'Publicado',
    completed: 'Completado',
    validated: 'Validado',
    waiting_validation: 'Pendiente de validación',
    rejected: 'Rechazado',
    in_committee: 'En Comité',
    approved: 'Aprobado',
    has_project: 'Con Proyecto',
    closed: 'Cerrado',
    failed: 'Fallido',
    tooltips: {
      draft: 'Borrador - Esperando procesamiento',
      submitted: 'Enviado - Pendiente de revisión',
      in_progress: 'En Progreso - Procesando',
      running: 'En Ejecución - Procesando ahora',
      done: 'Completado - Finalizado',
      published: 'Publicado - Visible para aplicantes',
      completed: 'Completado',
      validated: 'Validado - Listo para usar',
      in_committee: 'En Comité - En revisión',
      approved: 'Aprobado',
      has_project: 'Con Proyecto - Proyecto creado',
      closed: 'Cerrado',
      failed: 'Fallido - Se encontró un error',
    },
  },
  
  // Actions
  actions: {
    edit: 'Editar',
    cancel: 'Cancelar',
    processFiles: 'Procesar Archivos',
    viewDetails: 'Ver Detalles',
    viewReport: 'Ver Informe',
    download: 'Descargar',
    generateBrief: 'Generar Brief',
  },

  roles: {
    entrepreneur: 'emprendedor',
  },
  
  // Filters
  opportunityStages: {
    draft: 'Borrador',
    pending: 'Pendiente',
    inCommittee: 'En comité',
    approved: 'Aprobada',
    inAssembly: 'En ensamblaje',
    inLead: 'En lead',
    hasProject: 'Con proyecto',
    rejected: 'Rechazada',
  },
  filters: {
    vertical: 'Vertical',
    selectVertical: 'Seleccionar vertical',
    allVerticals: 'Todas las Verticales',
    enterprise: 'Empresa',
    consumer: 'Consumidor',
    b2b: 'B2B',
    b2c: 'B2C',
    dateRange: 'Rango de Fechas',
    selectDateRange: 'Seleccionar rango de fechas',
    allTime: 'Todo el Tiempo',
    lastWeek: 'Última Semana',
    lastMonth: 'Último Mes',
    lastQuarter: 'Último Trimestre',
    lastYear: 'Último Año',
    resetFilters: 'Restablecer Filtros',
    clear: 'Borrar filtros',
    type: 'Tipo',
    sector: 'Sector',
    urgency: 'Urgencia',
    urgencyOptions: {
      any: 'Cualquier urgencia',
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      none: 'Sin urgencia',
    },
    none: 'No hay filtros configurados.',
    regulatory: 'Regulatorio',
    sourceType: 'Fuente',
    technology: 'Tecnología',
    horizon: 'Horizonte',
    region: 'Región',
    sortBy: 'Ordenar por',
    sort: 'Ordenar',
    sortOptions: {
      newest: 'Más recientes primero',
      oldest: 'Más antiguos primero',
      titleAsc: 'Nombre A → Z',
      titleDesc: 'Nombre Z → A',
      urgencyDesc: 'Mayor urgencia',
      solutionsDesc: 'Más soluciones',
      priorityDesc: 'Mayor prioridad',
      priorityAsc: 'Menor prioridad',
      applicantsDesc: 'Más candidatos',
      filesDesc: 'Más archivos',
      opportunitiesDesc: 'Más oportunidades',
    },
  },

  // Discovery (cola de revisión)
  discovery: {
    title: 'descubrimiento',
    subtitle: 'Startups emergentes detectadas por el monitoreo diario de fuentes.',
    items: 'elementos',
    empty: 'Nada que mostrar.',
    view: 'Ver',
    filters: 'Filtros',
    filtersStatus: 'Estado',
    filtersKind: 'Tipo',
    filtersSector: 'Sector',
    filtersSource: 'Fuente',
    clearFilters: 'Borrar todos los filtros',
    search: 'Buscar descubrimientos...',
    kindNew: 'nueva',
    kindTracked: 'seguida',
    statusPending: 'Pendiente',
    statusApproved: 'Aprobada',
    statusRejected: 'Rechazada',
    approve: 'aprobar',
    dismiss: 'descartar',
    ingestingTitle: 'Ingiriendo {{name}}',
    approveSuccess: '{{name}} aprobada — generando perfil',
    approveError: 'Error al aprobar',
    dismissSuccess: '{{name}} descartada',
    dismissError: 'Error al descartar',
    viewInDealflow: 'ver en dealflow',
    companyIdentity: 'empresa',
    noSummary: 'Sin resumen disponible.',
    generating2D: 'generando análisis 2D…',
    problemMarket: 'problema y mercado',
    businessExecution: 'negocio y ejecución',
    source: 'fuente',
    origin: 'origen',
    article: 'artículo',
    sourceArticle: 'artículo fuente',
    discovered: 'descubierta',
    location: 'ubicación',
    stats: {
      total: 'Total',
      pending: 'Pendientes',
      approved: 'Aprobadas',
      rejected: 'Rechazadas',
    },
    sort: {
      label: 'Ordenar por',
      newest: 'Más recientes',
      oldest: 'Más antiguas',
      nameAsc: 'Nombre A → Z',
      nameDesc: 'Nombre Z → A',
    },
    date: {
      label: 'Fecha',
      all: 'Todo el tiempo',
      today: 'Hoy',
      yesterday: 'Ayer',
      last3: 'Últimos 3 días',
      thisWeek: 'Esta semana',
      lastWeek: 'Semana pasada',
      lastMonth: 'Mes pasado',
    },
  },

  // WebSocket
  connecting: 'Conectando...',
  connectionError: 'Error de Conexión',
  
  // Report
  reportTitle: 'Informe',
  generatedReport: 'Informe generado basado en tu refinamiento',
  exportPDF: 'Exportar PDF',
  shareReport: 'Compartir Informe',
  
  // Welcome screen
  welcome: 'Bienvenido a Terminus',
  selectThesis: 'Selecciona una línea de solución existente de la barra lateral o crea una nueva para comenzar a refinar tus ideas.',
  noTheses: 'Aún no hay líneas de solución. Haz clic en el botón + en la barra lateral para añadir tu primera línea de solución.',

  // Notifications
  thesisDeleted: 'Línea de solución eliminada',
  thesisDeletedDesc: 'Tu línea de solución ha sido eliminada.',
  refinementCompleted: 'Refinamiento completado',
  refinementCompletedDesc: 'Tu línea de solución está siendo procesada. El informe estará listo en breve.',

  // Notification System
  notifications: {
    title: 'Notificaciones',
    bell: 'Notificaciones',
    markAllRead: 'Marcar todo como leído',
    empty: 'Aún no hay notificaciones',
    viewAll: 'Ver todas las notificaciones',
    pageTitle: 'Notificaciones',
    allNotifications: 'Todas las notificaciones',
    unread: 'No leídas',
    read: 'Leídas',
    markAsRead: 'Marcar como leída',
    markAllAsRead: 'Marcar todo como leído',
    noNotifications: 'Sin notificaciones',
    noNotificationsDesc: '¡Estás al día! No hay notificaciones nuevas.',
    noUnread: 'Sin notificaciones no leídas',
    noUnreadDesc: 'Has leído todas tus notificaciones.',
    filterByType: 'Filtrar por tipo',
    allTypes: 'Todos los tipos',
    types: {
      system_alert: 'Alerta del sistema',
      action_required: 'Acción requerida',
      info: 'Información',
      application_status: 'Estado de solicitud',
      project_match: 'Proyecto coincidente',
      committee_assignment: 'Asignación de comité',
    },
    priority: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
    },
    tabs: {
      all: 'Todas',
      unread: 'No leídas',
    },
    refresh: 'Actualizar',
  },

  // Theme and Language
  theme: 'Tema',
  language: 'Idioma',
  light: 'Claro',
  dark: 'Oscuro',
  system: 'Sistema',
  english: 'Inglés',
  spanish: 'Español',

  // Thesis Actions
  thesisActions: {
    addSolution: 'Añadir Solución',
    addSolutionTooltip: 'Añadir una nueva solución manualmente',
    generateSingleSolution: 'Generar Solución Individual',
    generateSingleSolutionTooltip: 'Generar una solución individual usando IA',
    generateSolutionsBulk: 'Generar Soluciones en Lote',
    generateSolutionsBulkTooltip: 'Generar múltiples soluciones usando IA',
    generateReport: 'Generar Informe',
    generateReportTooltip: 'Generar un informe para esta línea de solución'
  },

  // NotFound page
  notFound: {
    404: '404',
    pageNotFound: 'página no encontrada.',
    description: 'la página que buscas no existe o ha sido movida.',
    goBack: 'volver',
    returnHome: 'volver al inicio',
  },

  // Error handling
  errors: {
    generic: 'Algo salió mal',
    validationError: 'Datos inválidos enviados',
    notFound: 'El recurso solicitado no fue encontrado',
    unauthorized: 'Por favor inicia sesión para continuar',
    forbidden: 'No tienes permiso para acceder a esto',
    serverError: 'Error del Servidor',
    serverErrorMessage: 'Estamos experimentando dificultades técnicas. Nuestro equipo ha sido notificado.',
    applicationError: 'Error de la Aplicación',
    applicationErrorMessage: 'Algo salió mal en este navegador. Por favor, inténtalo de nuevo.',
    badRequest: 'Solicitud inválida',
    conflict: 'Esta operación entra en conflicto con datos existentes',
    serviceUnavailable: 'Servicio temporalmente no disponible',
    networkError: 'Error de red',
    checkConnection: 'Por favor verifica tu conexión a internet',
    tryAgain: 'intentar de nuevo',
    goHome: 'ir al inicio',
    supportReference: 'Referencia: {{requestId}}',
    opportunityNotFound: 'Oportunidad no encontrada',
    saveFailed: 'No se pudieron guardar los cambios',
  },

  // CreateThesisForm
  createThesisForm: {
    thesisTitle: 'Título de la Línea de solución',
    enterThesisTitle: 'Ingrese el título de la línea de solución',
    titleRequired: 'El título de la línea de solución no puede estar vacío',
    creating: 'Creando...',
    createThesis: 'Crear Línea de solución',
  },

  // CreateMarketInsightForm
  createMarketInsightForm: {
    title: 'Crear Perspectiva de Mercado',
    nameLabel: 'Nombre',
    namePlaceholder: 'Ingrese el nombre de la perspectiva de mercado',
    categoryLabel: 'Categoría',
    categoryPlaceholder: 'Seleccione una categoría',
    createButton: 'Crear Perspectiva de Mercado',
    fillAllFields: 'Por favor complete todos los campos',
    created: 'Perspectiva de mercado creada exitosamente',
    createFailed: 'Error al crear perspectiva de mercado',
  },

  // Categories
  categories: {
    all: 'Todas',
    // Sector labels come from /api/sectors (display_name field), not the locale.
    industryCategory: 'Categoría de Industria',
  },

  // MarketInsightTable
  marketInsightTable: {
    name: 'Nombre',
    status: 'Estado',
    created: 'Creado',
    theses: 'Líneas de solución',
    opportunities: 'Oportunidades',
    fileName: 'Nombre del Archivo',
    actions: 'Acciones',
    searchPlaceholder: 'Buscar perspectivas de mercado...',
    noInsightsFound: 'No se encontraron perspectivas de mercado',
    noFiles: 'Sin archivos',
  },

  marketInsight: {
    downloadingBrief: 'Preparando el informe...',
    regenerate: 'Regenerar',
    files: 'Archivos',
    opportunities: 'Oportunidades',
    references: 'Referencias',
    referencesTitle: 'Referencias',
    comprehensiveReport: 'Informe Completo',
    metadata: 'Metadatos',
    aiGenerated: 'Generado por IA',
    sectionSources: 'Fuentes de esta sección',
    allReferences: 'Todas las Referencias',
    contents: 'Contenido',
    citations: 'Citas',
    noBriefYet: 'Aún no se ha generado el informe',
    runGenerateToCreate: 'Ejecuta el generador desde la cabecera para producir el informe.',
    primaryResearch: 'Investigación primaria',
    primaryResearchDesc: '{{count}} documento(s) de origen cargados para el análisis.',
    noWebSources: 'Sin fuentes web citadas.',
    viewFullBibliography: 'Ver bibliografía completa ({{count}})',
    unnamedStartup: 'Startup sin nombre',
    generatingOpportunityFrom: 'Generando oportunidad a partir de {{name}}…',
    generateOpportunityFailed: 'No se pudo generar la oportunidad',
    removeMatchFailed: 'No se pudo eliminar la startup',
    matchItemType: 'coincidencia',
    matchedStartups: 'Startups coincidentes',
    addStartup: 'Añadir startup',
    matchingInProgress: 'Buscando startups coincidentes...',
    noMatchedStartups: 'Aún no hay startups coincidentes.',
    manuallyAdded: 'Añadida manualmente',
    createOpportunity: 'crear oportunidad',
    startupAttached: 'Startup añadida a las coincidencias',
    startupsAttached: '{{count}} startups añadidas a las coincidencias',
    startupAttachFailed: 'No se pudieron añadir {{count}} startup(s)',
    attachFailed: 'No se pudo añadir la startup',
    attachPickerTitle: 'Añadir startups a las coincidencias',
    createNewStartup: 'Crear nueva startup',
    sectionLabels: {
      introduccion_ejecutiva: 'Introducción',
      macrotendencias: 'Macrotendencias',
      retos_estructurales: 'Retos',
      problemas_empresa: 'Problemas',
      tecnologias_emergentes: 'Tecnologías',
      prioridades_inversion: 'Inversión',
      relevancia_region: 'Relevancia',
      benchmark_china: 'Benchmark China',
    },
  },

  // DeleteConfirmationDialog
  deleteConfirmationDialog: {
    areYouSure: '¿Estás seguro?',
    defaultDescriptionWithName: 'Esta acción no se puede deshacer. Esto eliminará permanentemente la {{itemType}} "{{itemName}}".',
    defaultDescriptionWithoutName: 'Esta acción no se puede deshacer. Esto eliminará permanentemente esta {{itemType}}.',
    itemTypes: {
        'project lead': 'lead de proyecto',
      item: 'elemento',
      thesis: 'línea de solución',
      'market insight': 'perspectiva de mercado',
      user: 'usuario',
      solution: 'solución',
      committee: 'comité',
      opportunity: 'oportunidad',
      startup: 'startup',
    },
    consequences: {
      startup:
        'Se eliminarán su análisis, su one-pager, sus archivos, sus comentarios y su vector de búsqueda. Las entradas de descubrimiento que la crearon se conservan.',
      committee:
        'Se eliminarán sus decisiones, comentarios e informes, junto con sus vínculos a oportunidades y perspectivas de mercado. Las oportunidades, soluciones y project leads se conservan: los project leads simplemente dejan de referenciar este comité.',
    },
  },

  // UploadMarketInsightForm
  uploadMarketInsightForm: {
    title: 'Subir Perspectiva de Mercado',
    uploadButton: 'Subir Informe',
    uploadFailed: 'Error al subir el archivo',
  },

  // ThesisSection
  thesisSection: {
    id: 'ID',
    solutions: 'Soluciones',
    solution: 'Solución',
    report: 'Informe',
    success: 'Éxito',
    reportReady: 'Tu informe está listo.',
  },

  // SolutionList
  solutionList: {
    noSolutions: 'No hay soluciones disponibles para esta línea de solución.',
  },

  // ThesisTable
  thesisTable: {
    thesis: 'Línea de solución',
    status: 'Estado',
    solutionsCount: '# Soluciones',
    actions: 'Acciones',
    draft: 'borrador',
    openMenu: 'Abrir menú',
    editName: 'Editar Nombre',
    noThesesFound: 'No se encontraron líneas de solución.',
  },

  // ItemInputDialog
  itemInputDialog: {
    add: 'Añadir {{itemType}}',
    saveChanges: 'Guardar Cambios',
    adding: 'Añadiendo...',
    saving: 'Guardando...',
  },

  // SolutionItem
  solutionItem: {
    edit: 'Editar',
    remove: 'Eliminar',
    editTooltip: 'Editar esta solución',
    removeTooltip: 'Eliminar esta solución',
  },

  // Sidebar
  sidebar: {
    toggleSidebar: 'alternar barra lateral',
    terminusButton: "terminus",
    foundersHubButton: "founder's hub",
    gaiaButton: "gaia",
    documentationButton: "documentación",
    organizationButton: "organización",
    superadminButton: "superadmin",
    marketInsights: 'perspectivas de mercado',
    viewAllMarketInsights: 'ver todas las perspectivas de mercado',
    thesis: 'líneas de solución',
    viewAllThesis: 'ver todas las líneas de solución',
    settings: 'configuración',
    entrepreneur: {
      overview: 'resumen',
      opportunities: 'oportunidades',
      myOpportunities: 'mis ideas',
      sectors: 'sectores',
      applications: 'solicitudes',
      profile: 'perfil',
      home: 'inicio',
    },
    admin: {
      researchCenter: 'centro de investigación',
      marketInsights: 'perspectivas de mercado',
      dealflow: 'dealflow',
      discovery: 'descubrimiento',
      opportunities: 'oportunidades',
      validation: 'validación',
      projects: 'proyectos',
      committee: 'comité',
      postCommittee: 'post-comité',
      projectLeads: 'iniciativas de proyecto',
      shaping: 'modelado',
      archives: 'archivos',
      clients: 'clientes',
    },
  },

  // AllThesesView
  allThesesView: {
    title: 'Todas las Líneas de solución ({{count}})',
    createNewThesis: 'Crear Nueva Línea de solución',
    deleteThesis: 'Eliminar Línea de solución',
    thesisName: 'Nombre de la Línea de solución',
    editThesis: 'Editar Línea de solución: {{title}}',
    enterNewThesisName: 'Ingrese el nuevo nombre de la línea de solución',
  },

  // AllOpportunitiesView
  allOpportunitiesView: {
      items: 'elementos',
      searchPlaceholder: 'Buscar oportunidades...',
    title: 'Oportunidades ({{count}})',
    pageTitle: 'Oportunidades',
    subtitle: 'Oportunidades de inversión con definiciones de problemas y líneas de solución',
    createOpportunity: 'Crear Oportunidad',
    openMenu: 'Abrir menú',
    deleteTitle: 'Eliminar Oportunidad',
    errorLoading: 'Error al cargar oportunidades: {{message}}',
    stats: {
      total: 'Total',
      totalDesc: 'Número total de oportunidades en el sistema',
      draft: 'Borrador',
      draftDesc: 'Oportunidades aún siendo definidas o refinadas',
      pending: 'Pendiente',
      approved: 'Aprobadas',
      inAssembly: 'En ensamblaje',
      inLead: 'En lead',
      rejected: 'Rechazadas',
      validated: 'Validadas',
      validatedDesc: 'Oportunidades revisadas y aprobadas para inversión',
      withTheses: 'Con Tesis',
      withThesesDesc: 'Oportunidades con líneas de solución (tesis) definidas',
      inCommittee: 'En Comité',
      inCommitteeDesc: 'Oportunidades vinculadas a una sesión de comité de inversión',
      submitted: 'Enviadas',
      submittedDesc: 'Enviadas por emprendedores, pendientes de revisión',
      hasProject: 'Con Proyecto',
      hasProjectDesc: 'Oportunidades que se convirtieron en uno o más proyectos',
      closed: 'Cerradas',
      closedDesc: 'Oportunidades cuyo comité ha sido cerrado',
      timeToValidated: 'Time-To-Validation',
      timeToValidatedDesc: 'Tiempo promedio desde la creación hasta la validación',
      timeToCommittee: 'Time-To-Committee',
      timeToCommitteeDesc: 'Tiempo promedio desde la validación hasta el enlace con el comité',
      timeToProject: 'Time-To-Project',
      timeToProjectDesc: 'Tiempo promedio desde el enlace con el comité hasta el primer proyecto',
      totalCycle: 'Cycle Time',
      totalCycleDesc: 'Tiempo promedio total, desde la creación hasta el primer proyecto',
    },
    types: {
      label: 'Tipo',
      all: 'Cualquier tipo',
      marketInsight: 'Desde Insight de Mercado',
      entrepreneur: 'Emprendedor',
      internal: 'Interna',
    },
    legend: {
      hoverForDetails: 'Pasa el cursor sobre los indicadores para ver detalles',
      urgencyScore: 'Puntuación de urgencia',
      solutionLines: 'Líneas de solución',
      dataCompleteness: 'Completitud de datos (Problema → ICP → Urgencia → Soluciones)',
    },
  },

  // AllMarketInsightsView
  allMarketInsightsView: {
      progress: 'Progreso',
      filesCount_other: '{{count}} archivos',
      filesCount_one: '{{count}} archivo',
      clear: 'Limpiar',
    title: 'Perspectivas de Mercado ({{count}})',
    pageTitle: 'Investigación de Mercado',
    subtitle: 'Análisis impulsado por IA de documentos de industria para investigación de mercado',
    createNew: 'Crear Nueva Perspectiva de Mercado',
    createTitle: 'Crear Perspectiva de Mercado',
    uploadTitle: 'Subir Perspectiva de Mercado',
    openMenu: 'Abrir menú',
    deleteTitle: 'Eliminar Perspectiva de Mercado',
    errorLoading: 'Error al cargar perspectivas de mercado: {{message}}',
    stats: {
      timeToRun: 'Time-To-Run',
      timeToRunDesc: 'Tiempo promedio desde la creación hasta el inicio del procesamiento',
      timeToCompletion: 'Time-To-Completion',
      timeToCompletionDesc: 'Tiempo promedio desde el inicio del procesamiento hasta el reporte completado',
      webResearchPct: '% Investigación Web',
      webResearchPctDesc: 'Proporción promedio de archivos provenientes de investigación web frente a archivos subidos',
    },
  },

  // MarketInsightSidebar
  marketInsightSidebar: {
    title: 'Detalles de Perspectiva de Mercado',
    uploadDocuments: 'Subir Documentos',
    uploading: 'Subiendo',
    uploadedFiles: 'Archivos Subidos',
    analysisFilters: 'Filtros de Análisis',
    startProcessing: 'Iniciar Procesamiento',
    startingProcessing: 'Iniciando Procesamiento...',
    viewFullPage: 'Ver Página Completa',
    processingStarted: 'Procesamiento iniciado',
    processingStartedDesc: 'La perspectiva de mercado se está procesando',
    processingFailed: 'Error al iniciar procesamiento',
    uploadFileRequired: 'Sube al menos un archivo para continuar',
    completeRequiredFields: 'Completa todos los campos requeridos (marcados con *)',
    noSelection: 'No hay perspectiva de mercado seleccionada',
    opportunities: 'Oportunidades',
    opportunitiesGenerated: 'Generadas',
  },

  marketInsightProcessing: {
      failed: 'El procesamiento ha fallado',
    title: 'Procesando Perspectiva de Mercado',
    description: 'Analizando documentos y generando resumen de contexto...',
    statusProcessing: 'Generando oportunidades e insights',
    pleaseWait: 'Por favor espera, esto puede tomar unos momentos...',
    tryAgain: 'Intentar de Nuevo',
  },

  // MarketInsightView
  marketInsightView: {
    success: 'Éxito',
    notFound: 'Perspectiva de mercado no encontrada',
    loadFailed: 'Error al cargar perspectiva de mercado',
    processFiles: 'Procesar Archivos',
    overview: 'Resumen',
    files: 'Archivos',
    opportunities: 'Oportunidades',
    filters: 'Filtros',
    overviewTitle: 'Resumen de Perspectiva de Mercado',
    filesCount: 'Archivos',
    opportunitiesCount: 'Oportunidades',
    thesesCount: 'Líneas de solución',
    fileManagement: 'Gestión de Archivos',
    selectFile: 'Seleccionar Archivo',
    upload: 'Subir',
    uploading: 'Subiendo...',
    selectedFile: 'Archivo seleccionado',
    fileUploaded: 'Archivo subido exitosamente',
    uploadFailed: 'Error al subir archivo',
    processingStarted: 'Procesamiento iniciado',
    processingFailed: 'Error al iniciar procesamiento',
    noFiles: 'No hay archivos subidos aún',
    noOpportunities: 'No hay oportunidades generadas aún',
    theses: 'Líneas de solución',
    noFilters: 'No hay filtros aplicados',
    notSelected: 'Perspectiva de Mercado o Línea de solución no seleccionada.',
    solutionAdded: 'Solución añadida exitosamente.',
    solutionUpdated: 'Solución actualizada exitosamente.',
    solutionFailed: 'Error al {{action}} solución. {{message}}',
    add: 'añadir',
    update: 'actualizar',
    notSelectedForGeneration: 'Perspectiva de Mercado o Línea de solución no seleccionada para generación de solución.',
    solutionGenerationInitiated: 'Generación de solución iniciada.',
    generateSolutionFailed: 'Error al generar solución. {{message}}',
    solutionRemoved: 'Solución eliminada exitosamente.',
    removeSolutionFailed: 'Error al eliminar solución. {{message}}',
    notSelectedForReportGeneration: 'Perspectiva de Mercado o Línea de solución no seleccionada para generación de informe.',
    reportGenerationInitiated: 'Generación de informe iniciada.',
    generateReportFailed: 'Error al generar informe. {{message}}',
    notSelectedForSolutionsGeneration: 'Perspectiva de Mercado o Línea de solución no seleccionada para generación de soluciones.',
    allSolutionsGenerationInitiated: 'Generación de todas las soluciones iniciada para la línea de solución.',
    generateSolutionsFailed: 'Error al generar soluciones. {{message}}',
    solution: 'Solución',
    report: 'Informe',
    solutionItemType: 'Solución',
    addNewSolution: 'Añadir Nueva Solución',
    editSolution: 'Editar Solución',
    enterSolutionText: 'Ingrese el texto de la solución',
  },

  // VerifyEmailPage
  verifyEmail: {
    title: 'verifica tu email',
    sentTo: 'enviamos un enlace de verificación a {{email}}',
    verified: 'email verificado',
    verifiedDesc: 'tu email ha sido verificado exitosamente. redirigiendo...',
    continue: 'continuar a la revisión de solicitud',
    expired: 'este enlace de verificación ha expirado. solicita uno nuevo.',
    invalid: 'este enlace de verificación es inválido. solicita uno nuevo.',
    sendFailed: 'no se pudo enviar el email de verificación. intenta de nuevo.',
    step1Title: 'Revisa tu bandeja',
    step1Desc: 'Enviamos un enlace de verificación a tu dirección de email.',
    step2Title: 'Haz clic en el enlace',
    step2Desc: 'Abre el email y haz clic en el enlace de verificación.',
    step3Title: 'Verifica tu cuenta',
    step3Desc: 'Una vez verificado, tu solicitud pasará a revisión.',
    resend: 'reenviar email de verificación',
    resendIn: 'reenviar en {{seconds}}s',
    checkSpam: '¿no recibiste el email? revisa tu carpeta de spam o contáctanos en',
  },

  // WaitingPage
  waitingPage: {
    title: 'Solicitud en Revisión',
    description: '¡Gracias por enviar tu perfil! Nuestro equipo está revisando tu solicitud.',
    profileSubmitted: 'Perfil Enviado',
    profileSubmittedDesc: 'Tu solicitud ha sido enviada exitosamente para revisión.',
    underReview: 'En Revisión',
    underReviewDesc: 'Nuestro equipo está revisando tu solicitud actualmente. Esto típicamente toma 1-2 días hábiles.',
    emailNotification: 'Notificación por Email',
    emailNotificationDesc: 'Recibirás un correo electrónico en <strong>{{email}}</strong> una vez que tu solicitud sea procesada.',
    whatHappensNext: '¿Qué Sucede Después?',
    nextSteps: {
      step1: 'Nuestro equipo analiza tu experiencia laboral y habilidades para entender tu potencial emprendedor.',
      step2: 'En 1-2 días hábiles, recibes la aprobación con detalles de acceso o recomendaciones para mejorar tu perfil.',
      step3: 'Una vez aprobado, tendrás acceso completo a terminus.',
    },
    contactUs: '¿Preguntas? Contáctanos en',
  },

  // ConsentPage
  consentPage: {
    tagline: 'antes de comenzar',
    title: 'términos y consentimiento.',
    subtitle: 'Por favor revisa y acepta los siguientes acuerdos para continuar.',
    termsLabel: 'He leído y acepto los <termsLink>Términos de Servicio</termsLink> que regulan el uso de la plataforma',
    privacyLabel: 'He leído y acepto la <privacyLink>Política de Privacidad</privacyLink> sobre cómo se tratan mis datos personales',
    communicationsLabel: 'Me gustaría recibir novedades del ecosistema, eventos y oportunidades relevantes para mi perfil',
    communicationsOptional: '(opcional)',
    continueButton: 'aceptar y continuar',
    submitting: 'procesando...',
    mandatoryRequired: 'Debes aceptar los Términos de Servicio y la Política de Privacidad para continuar.',
    termsUrl: '/terms',
    privacyUrl: '/privacy',
  },
  legalPage: {
    termsTitle: 'términos de servicio.',
    privacyTitle: 'política de privacidad.',
    loading: 'Cargando documento...',
    error: 'No se pudo cargar el documento. Inténtalo de nuevo.',
    retry: 'Reintentar',
    courtesyNotice: 'Esta es una traducción de cortesía. La versión legalmente vinculante está en español.',
    back: 'Volver',
  },

  // OnboardingPage
  onboardingPage: {
    title: 'Completa Tu Perfil',
    stepProgress: 'Paso {{current}} de {{total}} - Ayúdanos a conocerte mejor',
    linkedInConnected: 'Perfil de LinkedIn Conectado',
    linkedInConnectedDesc: 'La información ha sido pre-llenada desde tu perfil de LinkedIn. Por favor revisa y actualiza según sea necesario.',
    cvUpdateBanner: 'Si tus datos de LinkedIn están incompletos o desactualizados, puedes subir tu CV para actualizar tu perfil.',
    cvUpdateButton: 'subir CV',
    cvUpdateParsing: 'leyendo tu CV...',
    cvUpdateSuccess: '¡CV analizado con éxito! Tu perfil ha sido actualizado.',

    // Step 0 - LinkedIn URL
    step0: {
      title: 'Autocompletar Perfil de LinkedIn',
      subtitle: 'Acelera tu proceso de registro permitiéndonos leer tu información profesional desde LinkedIn',
      urlLabel: 'URL de Perfil de LinkedIn',
      urlPlaceholder: 'linkedin.com/in/tunombre',
      urlHelp: 'Comparte tu URL de perfil de LinkedIn para rellenar automáticamente tus detalles profesionales',
      buttonIdle: 'Autocompletar Mi Perfil',
      buttonStarting: 'Comenzando...',
      buttonReading: 'Leyendo Tu Perfil... {{progress}}%',
      buttonUnderstanding: 'Comprendiendo Tu Perfil...',
      progressStarting: 'Comenzando...',
      progressReading: 'Leyendo tu perfil...',
      progressProcessing: 'Procesando...',
      errorTitle: 'Algo salió mal:',
      linkedinErrorTitle: 'No pudimos leer tu perfil de LinkedIn.',
      linkedinErrorDescription: 'Esto puede ocurrir si el perfil es privado o no está disponible temporalmente. Puedes intentarlo de nuevo o subir tu CV manualmente.',
      tryAgain: 'Intentar de Nuevo',
      uploadCvInstead: 'sube tu CV en su lugar',
      cvUploadTitle: 'sube tu CV.',
      cvUploadSubtitle: 'Sube tu currículum y extraeremos tu información profesional automáticamente.',
      cvDropzone: 'Arrastra y suelta tu CV aquí, o haz clic para buscar',
      cvAcceptedFormats: 'Formatos aceptados: PDF, DOCX, MD (máx 10MB)',
      cvUploading: 'Subiendo tu CV...',
      cvParsing: 'Leyendo tu CV...',
      cvParseError: 'No se pudo analizar tu CV. Intenta de nuevo con un archivo diferente.',
      backToLinkedin: 'intentar con LinkedIn en su lugar',
      howItWorksTitle: 'Cómo funciona:',
      howItWorks1: 'Leeremos tu información de perfil público',
      howItWorks2: 'Tu experiencia laboral, educación y habilidades se rellenarán automáticamente',
      howItWorks3: 'Puedes revisar y editar todo antes de enviar',
      howItWorks4: 'Esto te ahorra 5-10 minutos de entrada manual de datos',
    },

    // Step 1 - Personal Info
    step1: {
      title: 'revisa tu info',
      titleWithName: 'se ve bien, {{name}}',
      subtitle: 'revisa y edita tu información básica',
      firstName: 'Nombre',
      firstNamePlaceholder: 'Ingresa tu nombre',
      lastName: 'Apellido',
      lastNamePlaceholder: 'Ingresa tu apellido',
      location: 'Ubicación',
      locationPlaceholder: 'ej., Madrid, España',
      headline: 'Título Profesional',
      headlinePlaceholder: 'ej., Fundador y CEO en TechCorp',
      industry: 'Industria',
      industryPlaceholder: 'ej., Tecnología, Salud, Finanzas',
      summary: 'Resumen Profesional',
      summaryPlaceholder: 'Breve resumen de tu trayectoria profesional...',
    },

    // Step 2 - Work Experience
    step2: {
      title: 'Experiencia Laboral',
      subtitle: 'Añade tu experiencia profesional',
      workExperienceLabel: 'Experiencia Laboral',
      sameCompany: '(misma empresa)',
      jobTitle: 'Título del Puesto',
      jobTitlePlaceholder: 'ej., Ingeniero de Software Senior',
      company: 'Empresa',
      companyPlaceholder: 'ej., Google',
      location: 'Ubicación',
      locationPlaceholder: 'ej., Barcelona, España',
      startMonth: 'Mes de Inicio',
      startYear: 'Año de Inicio',
      endMonth: 'Mes de Fin',
      endYear: 'Año de Fin',
      currentlyWork: 'Actualmente trabajo aquí',
      description: 'Descripción',
      descriptionPlaceholder: 'Describe tus responsabilidades y logros...',
      addWorkExperience: 'Añadir Experiencia Laboral',
      role: 'cargo',
      roles: 'cargos',
    },

    // Step 3 - Education
    step3: {
      title: 'Educación',
      subtitle: 'Añade tu formación académica',
      educationLabel: 'Educación',
      school: 'Institución',
      schoolPlaceholder: 'ej., Universidad de Stanford',
      degree: 'Título',
      degreePlaceholder: 'ej., Licenciatura en Ciencias',
      fieldOfStudy: 'Campo de Estudio',
      fieldOfStudyPlaceholder: 'ej., Ciencias de la Computación',
      startYear: 'Año de Inicio',
      endYear: 'Año de Finalización',
      description: 'Descripción',
      descriptionPlaceholder: 'Actividades, sociedades, honores, etc...',
      addEducation: 'Añadir Educación',
    },

    // Step 4 - Certifications & Skills
    step4: {
      title: 'Certificaciones y Habilidades',
      subtitle: 'Añade certificaciones y habilidades',
      certificationsLabel: 'Certificaciones',
      certificationLabel: 'Certificación',
      certName: 'Nombre',
      certNamePlaceholder: 'ej., AWS Solutions Architect',
      certAuthority: 'Autoridad Emisora',
      certAuthorityPlaceholder: 'ej., Amazon Web Services',
      certLicense: 'Número de Licencia',
      certLicensePlaceholder: 'Opcional',
      certUrl: 'URL',
      certUrlPlaceholder: 'ej., https://...',
      certStartMonth: 'Mes de Inicio',
      certStartYear: 'Año de Inicio',
      certEndMonth: 'Mes de Vencimiento (si expira)',
      certEndYear: 'Año de Vencimiento',
      addCertification: 'Añadir Certificación',
      skillsLabel: 'Habilidades',
      skillPlaceholder: 'ej., JavaScript, Gestión de Proyectos, etc.',
      addSkill: 'Añadir Habilidad',
    },

    // Step 5 - Languages & Review
    step5: {
      title: 'Idiomas y Revisión',
      subtitle: 'Añade idiomas y revisa tu perfil',
      languagesLabel: 'Idiomas',
      languageName: 'Idioma (ej., Inglés, Español)',
      languageProficiency: 'Nivel (ej., Nativo, Fluido)',
      addLanguage: 'Añadir Idioma',
      reviewTitle: 'Listo para enviar',
      reviewDesc: 'Tu perfil está completo. Envía para continuar con tu solicitud.',
      noLanguages: 'No hay idiomas añadidos',
    },

    // Progress steps
    steps: {
      import: 'Importar',
      profile: 'Perfil',
      experience: 'Experiencia',
      complete: 'Completar',
    },

    // Proficiency levels
    proficiency: {
      native: 'Nativo',
      fluent: 'Fluido',
      professional: 'Profesional',
      intermediate: 'Intermedio',
      basic: 'Básico',
    },

    // Misc
    optional: 'opcional',
    noExperience: 'Aún no se ha añadido experiencia',
    noEducation: 'Aún no se ha añadido educación',
    present: 'Presente',

    // Validation
      validation: {
      firstNameRequired: 'el nombre es obligatorio',
      lastNameRequired: 'el apellido es obligatorio',
      headlineRequired: 'el titular es obligatorio',
      emptyWorkExperience: 'elimina las experiencias vacías o completa los datos',
      jobTitleRequired: 'el cargo es obligatorio en todas las experiencias',
      companyRequired: 'el nombre de la empresa es obligatorio en todas las experiencias',
      schoolRequired: 'el nombre del centro es obligatorio en todas las entradas de educación',
      languageNameRequired: 'el nombre del idioma es obligatorio en todas las entradas',
      certNameRequired: 'el nombre de la certificación es obligatorio en todas las entradas',
      locationRequired: 'la ubicación es obligatoria',
      startDateRequired: 'la fecha de inicio es obligatoria',
      endDateRequired: 'la fecha de fin es obligatoria',
      endDateBeforeStart: 'la fecha de fin no puede ser anterior a la de inicio',
      fixErrors: 'por favor corrige los errores antes de continuar',
    },

    // Navigation
    back: 'Atrás',
    next: 'Siguiente',
    continue: 'Continuar',
    submitting: 'Enviando...',
    submitForReview: 'Enviar para Revisión',
    platformTagline: 'plataforma de oportunidades para emprendedores.',

    // Toast messages
    toastUrlSubmitted: '¡URL de LinkedIn enviada! Leyendo tu perfil...',
    toastAutocompleted: '¡Perfil de LinkedIn autocompletado exitosamente!',
    toastInvalidUrl: 'Por favor ingresa una URL válida de perfil de LinkedIn (ej., linkedin.com/in/tunombre)',
    toastSubmitFailed: 'Error al enviar URL de LinkedIn',
    toastProfileSubmitted: '¡Perfil enviado para revisión!',
    toastLoginAgain: 'Por favor inicia sesión nuevamente para enviar tu perfil',
    toastProfileFailed: 'Error al enviar perfil: {{error}}',
  },

  // LinkedInParsingOverlay
  linkedInParsing: {
    title: 'Leyendo Tu Perfil de LinkedIn',
    description: 'Estamos leyendo tu perfil de LinkedIn para comprender tu trayectoria profesional. Este proceso generalmente toma 20-30 segundos.',
    progressComplete: '{{progress}}% completado',
    estimatedTime: 'Tiempo estimado restante: {{seconds}} segundos',
    statusStarting: 'Comenzando...',
    statusConnecting: 'Conectando a LinkedIn...',
    statusReading: 'Leyendo tu perfil...',
    statusUnderstanding: 'Comprendiendo tu experiencia laboral y educación...',
    statusReviewing: 'Revisando tus habilidades y certificaciones...',
    statusAlmostDone: 'Casi listo...',
    pleaseWait: 'Por favor espera, no cierres esta ventana',
    tryAgain: 'Intentar de Nuevo',
  },

  // Entrepreneur FSM States
  entrepreneurStatus: {
    PENDING_LINKEDIN_PARSE: 'Pendiente LinkedIn',
    PENDING_ONBOARDING: 'Pendiente Incorporación',
    PENDING_SUMMARY: 'En Revisión',
    PENDING_PASSED_PRESCORE: 'Pre-Evaluación Aprobada',
    PENDING_FAILED_PRESCORE: 'Pre-Evaluación Fallida',
    PENDING_WITH_NOTES: 'Revisión en Progreso',
    APPROVED: 'Aprobado',
    REJECTED: 'Rechazado',
    REJECTED_FAILED_PRESCORE: 'Rechazado - Pre-Evaluación Fallida',
    SUSPENDED: 'Suspendido',
    DELETED: 'Eliminado',
  },

  // Entrepreneur Dashboard
  entrepreneurDashboard: {
    welcome: 'Bienvenido de nuevo, {{name}}',
    activitySummary: 'Aquí está tu resumen de actividad',
    pendingOpportunities: {
      title: 'Oportunidades para Ti',
      emptyTitle: 'Aún No Hay Oportunidades',
      emptyState: 'Estamos seleccionando activamente oportunidades adaptadas a tu perfil y experiencia únicos',
    },
    recommendedOpportunities: 'Oportunidades Recomendadas',
    viewAllOpportunities: 'ver todas',
    noOpportunities: 'Aún No Hay Oportunidades',
    noOpportunitiesDesc: 'Estamos trabajando para encontrar las mejores oportunidades para ti. ¡Vuelve pronto!',
    stats: {
      total: 'Total',
      quickWins: 'Victorias Rápidas',
      strategic: 'Estratégicas',
      avgMatch: 'Coincidencia Prom.',
    },
    sectors: {
      title: 'Sectores',
      viewAll: 'Ver todos',
      opportunity: 'oportunidad',
      opportunities: 'oportunidades',
    },
    applications: {
      title: 'Mis Solicitudes',
      viewAll: 'Ver todas',
      noApplications: 'Sin solicitudes aún',
      noApplicationsDesc: 'Cuando apliques a oportunidades, aparecerán aquí para que puedas seguir su estado.',
    },
    card: {
      details: 'Detalles',
      apply: 'Aplicar',
      priority: 'Prioridad',
      match: 'Coincidencia',
    },
  },

  // Entrepreneur Opportunity Detail
  entrepreneurOpportunityDetail: {
    opportunityNotFound: 'Oportunidad no encontrada',
    applyNow: 'Aplicar Ahora',
    applicationFeatureComingSoon: 'Función de aplicación próximamente',
    scores: {
      priority: 'Prioridad',
      match: 'Coincidencia',
      urgency: 'Urgencia',
      difficulty: 'Dificultad',
    },
    whyWeRecommend: {
      title: 'Por qué te recomendamos esto',
      experienceRelevant: 'Tu experiencia en {{sector}} es muy relevante',
      rolesMatch: 'Tus roles coinciden con lo que buscamos',
      skillsAlign: 'Tus habilidades se alinean con los requisitos del proyecto',
    },
    tabs: {
      summary: 'Resumen',
      detail: 'Detalle',
      requirements: 'Qué Buscamos',
      faq: 'Preguntas Frecuentes',
    },
    summary: {
      noDescription: 'Sin descripción disponible.',
      vertical: 'Vertical',
      duration: 'Duración',
      experience: 'Experiencia',
      yearsPlus: '{{years}}+ años',
    },
    detail: {
      problemContext: 'Problema / Contexto',
      solutionProposal: 'Propuesta de Solución',
      scopeDeliverables: 'Alcance y Entregables',
      noDetails: 'No hay detalles adicionales disponibles.',
    },
    requirements: {
      targetRoles: 'Roles Objetivo',
      noRoles: 'No hay roles específicos listados.',
      minimumSeniority: 'Antigüedad Mínima',
      experienceRequired: '{{years}}+ años de experiencia requeridos',
      openToAll: 'Abierto a todos los niveles de experiencia',
      noRequirements: 'No hay requisitos específicos listados para esta oportunidad.',
    },
    faq: {
      selectionProcess: {
        question: '¿Cuál es el proceso de selección?',
        answer: 'El proceso de selección consta de varias etapas: revisión inicial de la solicitud, entrevista técnica para evaluar tu experiencia y enfoque, presentación de tu propuesta de solución, y evaluación final por el comité. El proceso completo típicamente toma 2-4 semanas.',
      },
      support: {
        question: '¿Qué apoyo recibiré?',
        answer: 'Los emprendedores seleccionados reciben apoyo integral que incluye: acceso al equipo técnico del cliente, mentoría dedicada, potencial financiamiento piloto, y conexiones con nuestra red de inversores y socios de la industria.',
      },
      timeCommitment: {
        question: '¿Cuál es el compromiso de tiempo?',
        answer: 'Esto depende del alcance del proyecto, pero típicamente requiere dedicación a tiempo completo durante la fase inicial de desarrollo. Trabajamos con emprendedores para establecer hitos y plazos claros que funcionen para ambas partes.',
      },
      afterApply: {
        question: '¿Qué sucede después de aplicar?',
        answer: 'Después de enviar tu solicitud, nuestro equipo revisará tu perfil y experiencia. Si hay una buena coincidencia, te contactaremos para programar una conversación inicial. Recibirás actualizaciones sobre el estado de tu solicitud a través de tu panel de control.',
      },
    },
  },

  opportunityStatus: {
    applied: 'Aplicado',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    saved: 'Guardado',
  },

  // Matched Opportunities
  matchedOpportunities: {
    title: 'oportunidades compatibles',
    description: 'Proyectos que coinciden con tu perfil basándose en tu experiencia y especialización',
    noMatches: 'no se encontraron coincidencias',
    noMatchesFiltered: 'Intenta ajustar tus filtros para ver más oportunidades.',
    noMatchesDesc: 'Estamos analizando continuamente nuevos proyectos. Vuelve pronto para coincidencias personalizadas.',
    stats: {
      total: 'Total',
      excellent: 'Excelente (85%+)',
      avgMatch: 'Coincidencia Prom.',
      avgDomain: 'Dominio Prom.',
    },
    filters: {
      label: 'Filtros',
      status: 'Estado',
      allStatus: 'Todos los estados',
      available: 'Disponible',
      saved: 'Guardada',
      applied: 'Aplicada',
      minScore: 'Puntuación Mín.',
      allScores: 'Todas las puntuaciones',
      excellent: '85%+ Excelente',
      strong: '70%+ Fuerte',
      good: '55%+ Buena',
      sector: 'Sector',
      allSectors: 'Todos los sectores',
      clear: 'Limpiar filtros',
    },
    card: {
      matchScore: 'Coincidencia',
      domainFit: 'Dominio',
      executionFit: 'Ejecución',
      save: 'Guardar',
      apply: 'Aplicar',
      dismiss: 'Descartar',
    },
  },

  // Matched Opportunity Detail
  matchedOpportunityDetail: {
    notFound: 'Oportunidad no encontrada',
    save: 'Guardar',
    apply: 'Aplicar',
    dismiss: 'Descartar esta oportunidad',
    scores: {
      match: 'Coincidencia',
      domain: 'Dominio',
      execution: 'Ejecución',
      urgency: 'Urgencia',
      difficulty: 'Dificultad',
    },
    whyMatched: {
      title: 'Por Qué Coincide Con Tu Perfil',
    },
    riskFlags: {
      title: 'Consideraciones',
    },
    tabs: {
      summary: 'Resumen',
      detail: 'Detalle del Proyecto',
      requirements: 'Requisitos',
    },
    summary: {
      noDescription: 'Sin descripción disponible.',
      vertical: 'Vertical',
      duration: 'Duración',
      experience: 'Experiencia',
      yearsPlus: '{{years}}+ años',
    },
    detail: {
      problemContext: 'Contexto del Problema',
      solutionProposal: 'Propuesta de Solución',
      scopeDeliverables: 'Alcance y Entregables',
      noDetails: 'No hay detalles adicionales disponibles.',
    },
    requirements: {
      targetRoles: 'Roles Objetivo',
      noRoles: 'No hay roles específicos definidos.',
      minimumSeniority: 'Antigüedad Mínima',
      experienceRequired: '{{years}}+ años de experiencia relevante requeridos',
      openToAll: 'Abierto a todos los niveles de experiencia',
    },
  },

  // Entrepreneur Industries
  entrepreneurIndustries: {
    title: 'Sectores',
    subtitle: 'Explora proyectos por sector de actividad',
    projectAvailable: '{{count}} proyecto disponible',
    projectsAvailable: '{{count}} proyectos disponibles',
    noProjects: 'Sin proyectos disponibles',
    // Keyed by canonical Sector.value (from /api/sectors). One entry per
    // approved category, nothing else.
    sectorDescriptions: {
      Energy: 'Generación y distribución energética',
      Aerospace: 'Aeroespacial y aviación',
      AgriTech: 'Tecnología agrícola',
      TourismSmartCities: 'Tecnología turística y smart cities',
      HealthBiotech: 'Salud y biotecnología',
      AdvancedTransport: 'Transporte avanzado y movilidad',
      AdvancedManufacturing: 'Manufactura avanzada e Industria 5.0',
      SustainableResources: 'Recursos sostenibles y materiales',
      SmartInfrastructure: 'Infraestructura inteligente y construcción',
      FinTech: 'Tecnología financiera',
      InsurTech: 'Tecnología de seguros',
    },
  },

  // Entrepreneur Industry Detail
  entrepreneurIndustryDetail: {
    sectorTitle: 'Sector: {{sector}}',
    sortBy: 'Ordenar por',
    sortOptions: {
      relevance: 'Relevancia para mí',
      priority: 'Prioridad',
      newest: 'Más recientes',
    },
    noOpportunities: 'Sin oportunidades en este sector',
    noOpportunitiesDesc: 'Vuelve más tarde para ver nuevas oportunidades en este sector.',
    moreInfo: '+ info',
    apply: 'Aplicar',
  },

  // Entrepreneur Applications
  entrepreneurApplications: {
    title: 'Mis Aplicaciones',
    subtitle: 'Sigue el estado de tus aplicaciones',
    noApplications: 'Sin aplicaciones aún',
    noApplicationsDesc: 'Cuando apliques a oportunidades, aparecerán aquí para que puedas seguir su progreso.',
    browseOpportunities: 'Explorar Oportunidades',
    appliedOn: 'Aplicado el {{date}}',
    viewDetails: 'Ver Detalles',
    status: {
      pending: 'En Revisión',
      accepted: 'Aceptado',
      rejected: 'No Seleccionado',
    },
  },

  // Entrepreneur Profile
  entrepreneurProfile: {
    title: 'Mi Perfil',
    subtitle: 'Tu perfil profesional e información de cuenta',
    preScore: 'Pre-score',
    fullTime: 'Tiempo completo',
    editProfile: 'Editar perfil',
    cancelEdit: 'Cancelar',
    saveProfile: 'Guardar cambios',
    saving: 'Guardando...',
    aboutMe: 'Sobre mí',
    experience: 'Experiencia',
    education: 'Educación',
    skills: 'Habilidades',
    languages: 'Idiomas',
    certifications: 'Certificaciones',
    years: 'años',
    present: 'Presente',
    sectorDistribution: 'Distribución por Sector',
    roleDistribution: 'Distribución por Rol',
    keywords: 'Keywords',
    preferences: 'Preferencias',
    sectorsOfInterest: 'Sectores de interés',
    availability: 'Disponibilidad',
    noSummary: 'Sin resumen agregado aún',
    noExperience: 'Sin experiencia agregada aún',
    noEducation: 'Sin educación agregada aún',
    noSkills: 'Sin habilidades agregadas aún',
    noLanguages: 'Sin idiomas agregados aún',
    noCertifications: 'Sin certificaciones agregadas aún',
  },

  entrepreneur: {
    myOpportunities: {
      title: 'mis ideas.',
      subtitle: 'Crea y gestiona tus ideas',
      create: 'Nueva idea',
      empty: 'Aún no has creado ninguna idea.',
      createFirst: 'Crea tu primera idea',
      submit: 'Enviar para revisión',
    },
    createOpportunity: {
      title: 'nueva oportunidad.',
      subtitle: 'Describe la oportunidad de negocio que has identificado',
      createButton: 'Crear oportunidad',
    },
    opportunity: {
      submitForReview: 'Enviar para revisión',
      submitted: 'Enviado',
      overview: 'Resumen',
      process: 'Proceso afectado',
      problem: 'Descripción del problema',
      committee: 'Comité',
    },
  },

  // Market Insight Filters
  marketInsightFilters: {
    // Groupings
    documentMetadata: 'Metadatos del Documento',
    businessThematicAxes: 'Ejes Temáticos de Negocio',
    geography: 'Geografía',
    regulationPolicies: 'Regulación y Políticas',
    technologyMaturity: 'Tecnología / Madurez',

    // Document Metadata filters
    sourceType: 'Tipo de Fuente',
    sourceTypeOptions: {
      strategicConsultant: 'Consultora Estratégica',
      fundInvestor: 'Fondo/Inversor',
      specializedMedia: 'Medio Especializado',
      publicOrganization: 'Organismo Público',
      thinkTankNgo: 'Think Tank / ONG',
      operatingCompany: 'Empresa Operadora',
      academic: 'Académico',
    },
    publicationDate: 'Fecha de Publicación',
    publicationDatePresets: {
      ytd: 'Lo que va de año',
      last90Days: 'Últimos 90 días',
      last6Months: 'Últimos 6 meses',
      lastYear: 'Último año',
      last2Years: 'Últimos 2 años',
    },
    analysisTemporalCoverage: 'Cobertura Temporal del Análisis',
    analysisTemporalCoverageOptions: {
      historical: 'Histórico',
      range2025_2030: '2025-2030',
      range2031_2040: '2031-2040',
      beyond2040: '>2040',
    },

    // Business Thematic Axes
    verticalSubsector: 'Vertical / Subsector',
    verticalSubsectorPlaceholder: 'Ingrese vertical o subsector',
    // Vertical labels come from /api/sectors (display_name), not the locale.

    // Geography
    region: 'Región',
    regionOptions: {
      global: 'Global',
      eu27: 'UE-27',
      northAmerica: 'Norteamérica',
      latam: 'LatAm',
      emea: 'EMEA',
      apac: 'APAC',
      spain: 'España',
    },

    // Regulation & Policies
    includeRegulatoryFramework: 'Incluir Marco Normativo',
    includeRegulatoryFrameworkOptions: {
      yes: 'Sí (menciona marco legal concreto)',
      no: 'No',
    },
    regulationType: 'Tipo de Regulación',
    regulationTypeOptions: {
      euDirective: 'Directiva UE',
      euRegulation: 'Reglamento UE',
      nationalLaw: 'Ley Nacional',
      technicalStandard: 'Norma Técnica',
      taxIncentive: 'Incentivo Fiscal',
      subsidyPublicFund: 'Subvención/Fondo Público',
    },

    // Technology / Maturity
    protagonistTechnology: 'Tecnología Protagonista',
    protagonistTechnologyPlaceholder: 'Ingrese tecnología protagonista (ej: IA, blockchain)',

    // Common filter labels
    selectPlaceholder: 'Seleccionar...',
    fromDate: 'Desde',
    toDate: 'Hasta',
    clearFilters: 'Limpiar Todos los Filtros',
    applyFilters: 'Aplicar Filtros',
    resetFilters: 'Restablecer Filtros',
  },

  // Opportunities
  opportunities: {
      generationFailed: 'La generación falló',
    deleteFailed: 'No se pudo eliminar la oportunidad',
    deleteSolutionFailed: 'No se pudo eliminar la solución',
    fromMarketInsight: 'Contexto de investigación',
    fromStartup: 'Startup de origen',
    startupContextDescription: 'Esta oportunidad se generó a partir de esta startup. Ábrela para revisar su perfil.',
    audit: {
      created: 'creada {{date}}',
      validated: 'validada {{date}}',
      validatedBy: 'validada por {{name}}{{date}}',
      decided: 'decidida {{date}}',
      decidedBy: 'decidida por {{name}}{{date}}',
    },
    entityName: 'Oportunidad',
    noOpportunitiesFound: 'No se encontraron oportunidades',
    statusSubmitted: 'Enviada',
    generatingDraft: 'Generando Borrador de Oportunidad',
    generatingDraftDescription: 'La IA está analizando y generando los detalles de la oportunidad...',
    analyzingForDraft: 'Analizando contexto y generando borrador...',
    draftGenerationComplete: '¡Borrador generado exitosamente! Haz clic para revisar.',
    draftGenerationNoResult: 'La generación del borrador no devolvió ningún resultado',
    draftGenerationFailed: 'Error al generar el borrador',
    processFilesPrompt: 'Procesa tus archivos cargados para generar oportunidades de mercado.',
    marketOpportunities: 'Oportunidades de Mercado ({{count}})',
    b2bAnalysis: 'Oportunidades B2B con análisis integral',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    editOpportunity: 'Editar Oportunidad',
    deleteOpportunity: 'Eliminar Oportunidad',
    validate: 'Validar',
    devalidate: 'Quitar de aprobación pendiente',
    markAsPendingValidation: 'Marcar como pendiente de validación',
    solutionLines: 'línea(s) de solución',
    solutions: 'solución(es)',

    // Dialog
    createOpportunity: 'Crear Nueva Oportunidad',
    updateOpportunity: 'Actualizar Oportunidad',
    newOpportunity: 'Nueva Oportunidad',
    newOpportunityDescription: 'Crear una nueva oportunidad de negocio',
    forMarketInsight: 'Para: {{name}}',
    lockedFromMarketInsight: 'Bloqueado desde los filtros de Perspectiva de Mercado',
    researchContext: 'Contexto de Investigación',
    researchContextDescription: 'Vincula una perspectiva de mercado para usar como contexto en la generación por IA',
    linkMarketInsight: 'Vincular Perspectiva de Mercado',
    linkMarketInsightDescription: 'Selecciona una perspectiva de mercado procesada para usar como contexto de investigación en la generación por IA.',
    noProcessedMarketInsights: 'No hay perspectivas de mercado procesadas disponibles. Ejecuta una perspectiva de mercado primero.',
    noMatchingMarketInsights: 'Ninguna perspectiva de mercado coincide con tu búsqueda.',

    // Opportunity Model
    opportunity: {
      sectionName: '📋 Oportunidad',
      title: 'Título de la Oportunidad',
      titlePlaceholder: 'Título breve de la oportunidad (2-5 palabras)...',
      slug: 'Identificador',
      slugPlaceholder: 'OP-SECTOR-VERTICAL-01',
      slugHelper: 'Formato auto-generado: OP-SECTOR-VERTICAL-NN',
      sector: 'Sector',
      sectorPlaceholder: 'ej., ENERGÍA, TECH, FINANZAS',
      vertical: 'Vertical / Industria',
      verticalPlaceholder: 'ej., ELECTRICIDAD, FINTECH, AGRITECH',
      affectedProcess: 'Proceso de Negocio Afectado',
      affectedProcessPlaceholder: 'Qué proceso de negocio es impactado...',
    },

    // ICP Model
    icp: {
      sectionName: '🎯 PCI',
      segment: 'Segmento de Cliente Objetivo',
      segmentPlaceholder: 'Describe el segmento de cliente objetivo...',
      size: 'Mercado Total Direccionable (TAM)',
      sizePlaceholder: 'ej., $500M TAM, 10,000 empresas en LATAM',
      keyRoles: 'Roles Tomadores de Decisión Clave',
      keyRolesPlaceholder: 'CTO, CFO, Director de Operaciones',
      keyRolesHelper: 'Roles separados por comas',
    },

    // Problem Model
    problem: {
      sectionName: '⚠️ Problema',
      description: 'Declaración del Problema',
      descriptionPlaceholder: 'Describe el problema central que aborda esta oportunidad...',
      kpiMetric: 'KPI Actual Medido',
      kpiMetricPlaceholder: 'ej., Tiempo de Respuesta, Costo por Transacción, Tasa de Error',
      kpiValue: 'Valor Actual del KPI (Línea Base)',
      kpiValuePlaceholder: 'ej., 120',
      kpiUnit: 'Unidad de Medición del KPI',
      kpiUnitPlaceholder: 'ej., segundos, USD, porcentaje',
      kpiPeriod: 'Período de Medición del KPI',
      kpiPeriodPlaceholder: 'ej., promedio mensual, Q1 2024',
      painType: 'Categoría del Punto de Dolor',
      painTypePlaceholder: 'costo | tiempo | riesgo | calidad',
      painTypeHelper: 'Tipo principal de dolor que aborda',
      painEstimatedImpact: 'Impacto Estimado del Dolor',
      painEstimatedImpactPlaceholder: 'Cuantifica el impacto (ej., $2M pérdida anual, 40% desperdicio de tiempo)...',
      painSource: 'Fuente del Dolor / Cita',
      painSourcePlaceholder: 'Referencia o cita de la fuente para este punto de dolor',
    },

    // MarketWindow Model
    marketWindow: {
      sectionName: '⏰ VentanaDeMercado',
      urgencyScore: 'Puntuación de Urgencia (1-5)',
      urgencyScorePlaceholder: '1-5',
      urgencyScoreHelper: '1 = urgencia baja, 5 = crítico/sensible al tiempo',
      regulatoryOrContract: 'Impulsores Regulatorios/Contractuales',
      regulatoryOrContractPlaceholder: 'Requisitos regulatorios externos u obligaciones contractuales impulsando esto...',
      marketTriggers: 'Detonantes y Eventos de Mercado',
      marketTriggersPlaceholder: 'Nueva regulación llegando Q2 2024\nCompetidor principal lanzó producto similar\nSubsidio gubernamental anunciado',
      marketTriggersHelper: 'Un detonante por línea',
    },

    // Constraints Model
    constraints: {
      sectionName: '🔒 Restricciones',
      data: 'Disponibilidad de Datos y Requisitos',
      dataPlaceholder: '¿Qué datos se necesitan? ¿Están disponibles? ¿Preocupaciones de calidad?',
      it: 'Integración de Sistemas IT',
      itPlaceholder: 'Integraciones requeridas, sistemas legados, APIs necesarias...',
      compliance: 'Cumplimiento Normativo',
      compliancePlaceholder: 'GDPR, HIPAA, SOC2, regulaciones específicas de la industria...',
      dataResidency: 'Requisitos de Residencia de Datos',
      dataResidencyPlaceholder: 'ej., Solo-UE, Solo-EE.UU., Solo-LATAM',
      onpremCloud: 'Modelo de Despliegue',
      onpremCloudPlaceholder: 'on-prem | nube | híbrido',
      onpremCloudHelper: 'Despliegue en premisas, nube o híbrido',
    },

    // SuccessObjective Model
    successObjective: {
      sectionName: '🎯 ObjetivoDeÉxito',
      kpiAfter: 'KPI Objetivo Después de la Implementación',
      kpiAfterPlaceholder: 'ej., 30 segundos (desde 120 segundos línea base)',
      expectedImprovement: 'Mejora Esperada',
      expectedImprovementPlaceholder: 'ej., 75% reducción, 3x aumento, $1M ahorro anual',
      maxTtvDays: 'Máximo Tiempo-a-Valor (días)',
      maxTtvDaysPlaceholder: 'ej., 90',
      maxTtvDaysHelper: 'Tiempo máximo aceptable para ver valor',
      maxPaybackMonths: 'Período Máximo de Recuperación (meses)',
      maxPaybackMonthsPlaceholder: 'ej., 12',
      maxPaybackMonthsHelper: 'Tiempo máximo aceptable para recuperar la inversión',
    },

    // BenchmarkGap Model
    benchmarkGap: {
      sectionName: '🌍 BrechaDeReferencia',
      notableCases: 'Casos de Referencia Notables',
      notableCasesPlaceholder: 'Casos de estudio notables de China, UE, EE.UU. mostrando soluciones probadas...',
      gapComparison: 'Brecha vs Mercados Avanzados',
      gapComparisonPlaceholder: '¿Cómo se compara el estado actual con líderes de China/UE/EE.UU.? Costo, velocidad, ventajas tecnológicas...',
      transferabilityRisks: 'Riesgos de Transferibilidad',
      transferabilityRisksPlaceholder: 'Riesgos al adaptar soluciones de otros mercados (culturales, regulatorios, infraestructura)...',
    },

    // Display fields (for OpportunityTableItem and OpportunityBody)
    display: {
      basicInfo: 'Información Básica',
      description: 'Descripción',
      aiContext: 'Contexto generado por IA',
      affectedProcess: 'Proceso Afectado',
      idealCustomerProfile: 'Perfil de Cliente Ideal',
      segment: 'Segmento',
      marketSize: 'Tamaño de Mercado',
      keyRoles: 'Roles Clave',
      problemDefinition: 'Definición del Problema',
      currentKPI: 'KPI Actual',
      painType: 'Tipo de Dolor',
      marketWindow: 'Ventana de Mercado',
      urgencyScore: 'Puntuación de Urgencia',
      regulatoryContract: 'Regulatorio/Contrato',
      marketTriggers: 'Detonantes de Mercado',
      constraints: 'Restricciones',
      data: 'Datos',
      itIntegration: 'Integración IT',
      compliance: 'Cumplimiento',
      dataResidency: 'Residencia de Datos',
      successObjectives: 'Objetivos de Éxito',
      targetKPI: 'KPI Objetivo',
      expectedImprovement: 'Mejora Esperada',
      maxTTV: 'TTV Máximo',
      maxPayback: 'Retorno Máximo',
      benchmarkGapAnalysis: 'Análisis de Brecha y Referencia',
      notableCases: 'Casos Notables',
      gapComparison: 'Comparación de Brecha',
      transferabilityRisks: 'Riesgos de Transferibilidad',
      chinaSignals: 'Señales de mercado',
      rootCauses: 'Causas raíz',
      currentState: 'Estado actual',
    },
  },
  solutionLines: {
    itemType: 'línea de solución',
    generate: 'Generar con IA',
    add: 'Añadir línea',
    empty:
      'Todavía no hay líneas de solución. Genéralas con IA, o añade una tú si ya tienes clara la estrategia.',
    generating: 'Generando líneas de solución',
    generatingDescription:
      'Explorando las estrategias que podrían resolver esta oportunidad, una por ángulo.',
    analyzing: 'Explorando ángulos...',
    generateFailed: 'No se han podido generar las líneas de solución',
    createFailed: 'No se ha podido crear la línea de solución',
    updateFailed: 'No se ha podido actualizar la línea de solución',
    deleteFailed: 'No se ha podido eliminar la línea de solución',
    newTitle: 'Nueva línea de solución',
    newDescription:
      'Dale nombre a la estrategia. Si dejas el ángulo y la descripción vacíos, los escribe el agente; si rellenas alguno, la línea se guarda tal cual.',
    expanding: 'Ampliando la línea de solución',
    expandingDescription:
      'Deduciendo el ángulo y la descripción de «{{title}}» a partir de esta oportunidad.',
    editTitle: 'Editar línea de solución',
    editDescription: 'Cambia cómo se llama y se describe esta estrategia.',
    regenerate: 'Regenerar línea',
    regenerating: 'Regenerando la línea de solución',
    regeneratingDescription:
      'Reescribiendo esta línea y recalculando la tipología de sus soluciones.',
    regenerateFailed: 'No se pudo regenerar la línea de solución',
    stats: {
      lines_one: '{{count}} línea de solución',
      lines_other: '{{count}} líneas de solución',
    },
    fields: {
      title: 'Título',
      titlePlaceholder: 'p. ej. Programación Predictiva de Atraques',
      angle: 'Ángulo',
      anglePlaceholder: 'p. ej. PROCESO, TECNOLOGÍA, DATOS...',
      description: 'Descripción',
      descriptionPlaceholder: 'Qué se hace y por qué resuelve el problema desde ese ángulo.',
    },
  },
  solutions: {
    generateBulk: 'Generar (5)',
    generating: 'Generando...',
    entityName: 'Solución',
    title: 'Soluciones ({{count}})',
    addSolution: 'Agregar Solución',
    generatingDraft: 'Generando Borrador de Solución',
    generatingDraftDescription: 'La IA está analizando la oportunidad y generando una solución...',
    regenerate: 'Regenerar',
    regenerating: 'Regenerando hipótesis',
    regeneratingDescription: 'Actualizando el resumen, los datos y las startups asociadas conservando el título...',
    startupsCountTooltip: 'Startups encontradas',
    startups: 'Startups',
    partnerArchetype: 'Arquetipo de socio',
    partnerArchetypePlaceholder: 'p. ej. fabricante de drones (OEM)',
    partnerArchetypeHelper: 'El tipo de startup/socio que lo entrega',
    solutionType: 'Tipo de solución',
    solutionTypePlaceholder: 'Elige uno',
    solutionTypeHelper:
      'A qué distancia está esta solución de lo que el problema pide literalmente.',
    solutionTypes: {
      direct: 'Solución directa',
      adjacent_solution: 'Solución adyacente',
      adjacent_technology: 'Tecnología adyacente',
    },
    uncategorized: 'Sin línea de solución',
    noSolutionsInLine: 'Todavía no hay soluciones en esta línea.',
    stats: {
      validated: '{{count}} validadas',
      approved: '{{count}} aprobadas',
      rejected: '{{count}} rechazadas',
      reports: '{{count}} informes',
      avgScore: 'prom {{score}}/100',
    },
    badges: {
      report: 'Informe',
    },
    editSolution: 'Editar Solución',
    validationItems: 'Elementos de validación para esta línea de solución',
    content: 'Contenido',
    contentPlaceholder: 'Ingrese el contenido de la solución...',
    editDescription: 'Actualice el contenido de la solución',
    createDescription: 'Agregue una nueva solución para validar esta línea de solución',
    create: 'Crear',
    update: 'Actualizar',
    dialog: {
      sections: {
        basicInfo: 'Información Básica',
        coveragePartner: 'Socio',
        solutionDetails: 'Detalles de la Solución',
        citationsScoring: 'Citas y Puntuación',
        scoreBreakdown: 'Desglose de Puntuación',
      },
      solutionTitle: 'Título de la Solución',
      solutionTitlePlaceholder: 'ej., Gemelo Operativo de Red',
      scope: 'Alcance',
      scopePlaceholder: 'Qué hace la solución y cómo aborda el proceso afectado...',
      scopeHelper: 'Escribe con fluidez — las fuentes van en la lista de Citas de Evidencia abajo, no en línea.',
      technology: 'Tecnología',
      technologyPlaceholder: 'Enfoque técnico, patrones, arquitectura...',
      technologyHelper: 'Escribe con fluidez — las fuentes van en la lista de Citas de Evidencia abajo, no en línea.',
      operation: 'Operación',
      operationPlaceholder: 'Cómo opera, modelo de despliegue, enfoque de integración...',
      operationHelper: 'Escribe con fluidez — las fuentes van en la lista de Citas de Evidencia abajo, no en línea.',
      businessModel: 'Modelo de Negocio',
      businessModelPlaceholder: 'Precios, licencias, modelo de compromiso...',
      businessModelHelper: 'Escribe con fluidez — las fuentes van en la lista de Citas de Evidencia abajo, no en línea.',
      evidenceCitations: 'Citas de Evidencia',
      evidenceCitationsPlaceholder: 'Título Fuente - https://ejemplo.com (scope, technology)\nOtra Fuente - https://ejemplo.com (operation)',
      evidenceCitationsHelper: 'Una cita por línea: título - url (campos referenciados)',
      totalScore: 'Puntuación Total',
      totalScorePlaceholder: '87',
      totalScoreHelper: 'Suma de todos los subpuntajes (máx 100)',
      lineFitScore: 'Puntuación de Ajuste de Línea',
      lineFitScorePlaceholder: '25',
      lineFitScoreHelper: '0-30 puntos',
      startupFitScore: 'Puntuación de Ajuste Startup',
      startupFitScorePlaceholder: '25',
      startupFitScoreHelper: '0-30 puntos',
      dataFeasibilityScore: 'Puntuación de Viabilidad de Datos',
      dataFeasibilityScorePlaceholder: '13',
      dataFeasibilityScoreHelper: '0-15 puntos',
      ttvPaybackScore: 'Puntuación TTV/Retorno',
      ttvPaybackScorePlaceholder: '8',
      ttvPaybackScoreHelper: '0-10 puntos',
      transferabilityScore: 'Puntuación de Transferibilidad',
      transferabilityScorePlaceholder: '4',
      transferabilityScoreHelper: '0-5 puntos',
      businessModelIcpScore: 'Puntuación Modelo de Negocio/ICP',
      businessModelIcpScorePlaceholder: '7',
      businessModelIcpScoreHelper: '0-10 puntos',
    },
  },

  committee: {
      unnamed: 'Comité {{id}}',
      errorLoading: 'Error al cargar comités: {{message}}',
    all_committees: 'Todos los Comités',
    committees: 'Comités',
    pending_pre_committees: 'Pendiente Pre-Comité',
    pre_done_committees: 'Pre-Comité Completado',
    post_done_committees: 'Post-Comité Completado',
    title: 'Comités',
    subtitle: 'Revisar y gestionar sesiones de comité',
    list_subtitle: 'Revisar y gestionar comités de inversión',
    view_subtitle: 'Revisar y priorizar oportunidades listas para el comité',
    pre_committee_package: 'Paquete Pre-Comité',
    committee_session: 'Sesión de Comité',
    opportunities_label: 'Oportunidades',
    solution_lines_label: 'Líneas de Solución',
    validated_opportunities: 'Oportunidades Validadas',
    validated_opportunities_subtitle: 'Oportunidades del documento de perspectiva de mercado',
    items_count: '{{count}} elementos',
    add_opportunity: 'Añadir',
    no_committees: 'No se encontraron comités',
    no_committees_filter: 'No se encontraron comités con este estado',
    error: 'Error al cargar los comités',
    error_loading: 'Error al cargar comités',
    pre_date: 'Pre-Comité',
    post_date: 'Post-Comité',
    pre_date_label: 'Pre',
    post_date_label: 'Post',
    back_to_list: 'Volver a Comités',
    overview: 'Resumen',
    total_committees: '{{count}} comités en total',
    status: {
      all: 'Todos los Estados',
      pending_pre: 'Pendiente Pre-Comité',
      pre_done: 'Pre-Comité Completado',
      post_done: 'En Modelado',
      closed: 'Cerrado',
    },
    status_label: {
      pending: 'Pendiente',
      pre_done: 'Pre Completado',
      completed: 'Completado',
    },
    status_filter: 'Filtro de Estado',
    search_placeholder: 'Buscar comités...',
    generatingReport: 'Generando Informe Pre-Comité',
    generatingDescription: 'Por favor espere mientras compilamos su informe...',
    analyzingContent: 'Analizando oportunidades, tesis y soluciones...',
    reportDownloaded: '¡Informe descargado exitosamente!',
    reportError: 'Por favor intente de nuevo o contacte soporte si el problema persiste.',
    pre_committee_report: 'Informe Pre-Comité',
    post_committee_report: 'Informe Post-Comité',
    report_status: {
      ready: 'Listo para generar',
      generated: 'Informe generado',
      approve_first: 'Apruebe soluciones para generar informe',
      no_opportunities: 'Sin oportunidades para exportar',
    },
    opportunities_count: '{{count}} oportunidades',
    theses_count: '{{count}} líneas de solución',
    solutions_count: '{{count}} soluciones',
    generating: 'Generando...',
    download_report: 'Descargar Informe',
    generate_report: 'Generar Informe',
    download_current_document: 'Descargar documento actual',
    regenerate_document: 'Regenerar documento',
    package_content: 'Contenido del Paquete',
    package_content_description: 'Oportunidades, líneas de solución y soluciones para revisión',
    market_insight_opportunities: 'Oportunidades de Perspectiva de Mercado',
    opportunities_heading: 'Oportunidades',
    no_opportunities: 'Sin oportunidades',
    no_opportunities_description: 'Añada oportunidades para incluirlas en esta revisión de comité.',
    add_opportunity_title: 'Añadir Oportunidad',
    add_opportunity_dialog_description: 'Oportunidades pendientes de validación, no vinculadas aún a ningún comité.',
    opportunities_from_insight: 'Oportunidades de Perspectiva de Mercado',
    notes_saved: 'Notas guardadas',
    notes_saved_description: 'Las notas del comité se han guardado correctamente.',
    notes_error: 'Error al guardar notas',
    post_report_generated: 'Informe Descargado',
    post_report_downloaded: 'Su informe post-comité ha sido generado y descargado.',
    post_report_error: 'Error',
    post_report_error_description: 'Error al generar el informe post-comité. Por favor intente de nuevo.',
    decision_saved: 'Decisión guardada',
    decision_error: 'Error al guardar decisión',
    decision: {
      approved: 'Aprobado',
      rejected: 'Rechazado',
      pending: 'Pendiente',
      approved_solutions: 'Sol. aprobadas',
      rejected_solutions: 'Sol. rechazadas',
      approved_opportunities: 'Opp. aprobadas',
      rejected_opportunities: 'Opp. rechazadas',
      notesPlaceholder: 'Notas para esta solución (guardado automático)',
      opportunityNotesPlaceholder: 'Notas para esta oportunidad (guardado automático)',
      addNote: 'Añadir nota',
      cascadedApproved: 'auto-aprobado',
      cascadedRejected: 'auto-rechazado',
      cascadedHint:
        'Aprobada automáticamente con la oportunidad. Haz clic en aprobar para confirmar.',
      cascadedRejectedHint:
        'Rechazada automáticamente con la oportunidad. Haz clic en rechazar para confirmar.',
      confirmCascadedHint: 'Confirmar esta auto-aprobación como tu decisión',
      confirmCascadedRejectHint: 'Confirmar este auto-rechazo como tu decisión',
    },
    decisions_description: 'Vote sobre oportunidades e hipótesis',
    opportunity_notes_placeholder: 'Añadir notas del comité para esta oportunidad...',
    solution_notes_placeholder: 'Añadir notas del comité para esta hipótesis...',
    decided_count: '{{decided}}/{{total}} decididos',
    count_approved: '{{count}} aprobados',
    count_rejected: '{{count}} rechazados',
    generating_post_committee_report: 'Generando Informe Post-Comité',
    minutes_button: 'Acta y transcripción',
    minutes_panel_title: 'Acta y transcripción',
    minutes_panel_description:
      'Sube la transcripción de la reunión. El acta se genera automáticamente a partir de ella y puede editarse antes de cerrar el comité.',
    minutes_generating: 'Generando el acta a partir de la transcripción…',
    minutes_empty_closed: 'No se registró acta para este comité.',
    notes_title: 'Acta de Sesión',
    notes_description:
      'Generada automáticamente a partir de la transcripción. Revísala y edítala antes de cerrar.',
    notes_placeholder: 'Sube una transcripción para generar el acta, o escríbela aquí…',
    save_minutes: 'Guardar Acta',
    transcript_title: 'Transcripción de la Reunión',
    transcript_description:
      'Sube la transcripción de la reunión. El acta se genera automáticamente a partir de ella.',
    transcript_uploaded: 'Transcripción subida',
    transcript_upload: 'Subir',
    transcript_replace: 'Reemplazar',
    transcript_lang_es: 'Español',
    transcript_lang_en: 'Inglés',
    transcript_lang_hint:
      'Idioma predominante de la reunión — el acta se redacta en él. Las frases mezcladas en el otro idioma se gestionan igualmente.',
    validated_elements: 'Decisiones de Solución',
    solution_decisions_description: 'Vote sobre cada solución para determinar los próximos pasos',
    no_validated_opportunities: 'Sin oportunidades validadas',
    no_validated_theses: 'Sin líneas de solución validadas',
    no_validated_solutions: 'Sin soluciones validadas',
    validated_theses: 'Líneas de Solución',
    validated_solutions: 'Soluciones',
    add: 'Añadir',
    summary: 'Resumen',
    market_insights: 'Market Insights',
    no_market_insights: 'Sin market insights',
    no_market_insights_description: 'Añade market insights para incluirlos en la revisión de este comité.',
    add_market_insight: 'Añadir Market Insight',
    add_market_insight_description: 'Selecciona un market insight para añadir a este comité.',
    search_market_insights: 'Buscar market insights...',
    no_available_market_insights: 'No hay market insights disponibles para añadir.',
    no_matching_market_insights: 'Ningún market insight coincide con tu búsqueda.',
    error_loading_market_insights: 'Error al cargar market insights',
    add_n_items: 'Añadir ({{count}})',
    already_added: 'Ya añadido',
    in_n_committees: 'En {{count}} comité(s)',
    validated_label: 'validadas',
    remove_market_insight: 'Eliminar Market Insight',
    remove_market_insight_description: '¿Está seguro de que desea eliminar este market insight del comité? No será eliminado y puede añadirse de nuevo más tarde.',
    search_opportunities: 'Buscar oportunidades...',
    no_available_opportunities: 'No hay oportunidades pendientes de validación disponibles.',
    no_matching_opportunities: 'Ninguna oportunidad coincide con tu búsqueda.',
    workflow: {
      title: 'Flujo de Comité',
      pending_pre: 'Pendiente Pre-Comité',
      pending_pre_desc: 'Esperando informe pre-comité',
      pre_done: 'Pre-Comité Completado',
      pre_done_desc: 'Informe pre listo, esperando post-comité',
      post_done: 'En modelado',
      post_done_desc: 'Decisiones finalizadas; las oportunidades aprobadas se ensamblan en iniciativas de proyecto',
      closed: 'Cerrado',
      closed_desc: 'Totalmente cerrado; cada oportunidad aprobada asignada a una iniciativa de proyecto',
      current: '← Actual',
      not_started: 'Flujo de comité aún no iniciado',
      not_started_label: 'No Iniciado',
    },
    report: {
        error_badge: 'Error {{label}}',
      pre_title: 'Informe Pre-Comité',
      post_title: 'Informe Post-Comité',
      pre_desc: 'El informe pre-comité resume oportunidades y tesis antes de la reunión',
      post_desc: 'El informe post-comité documenta decisiones y próximos pasos después de la reunión',
      error: 'Error en Informe {{label}}-Comité',
      error_desc: 'Falló la generación del informe. Haga clic para ver detalles y reintentar.',
      ready: 'Informe {{label}}-Comité Listo',
    },
    decisions_summary: {
      title: 'Decisiones del Comité',
      total: '{{count}} total',
      approved_desc: 'oportunidades avanzando',
      rejected_desc: 'oportunidades rechazadas',
      pending_desc: 'esperando decisión',
    },
    stats: {
      total: 'Total',
      total_desc: 'Total de comités creados en el sistema',
      pending_pre: 'Pre Pendiente',
      pending_pre_desc: 'Comités esperando reunión pre-comité',
      pre_done: 'Pre Completado',
      pre_done_desc: 'Pre-comité completado, esperando post-comité',
      completed: 'Completado',
      completed_desc: 'Flujo de comité completo con decisiones finales',
      in_shaping: 'En Modelado',
      in_shaping_desc: 'Decisiones finalizadas; las oportunidades aprobadas se ensamblan en iniciativas de proyecto.',
      closed: 'Cerrado',
      closed_desc: 'Totalmente cerrado: cada oportunidad aprobada se asignó a una iniciativa de proyecto.',
      with_decisions: 'Con Decisiones',
      with_decisions_desc: 'Comités que han registrado decisiones de oportunidad',
    },
    legend: {
      workflow_stage: 'Etapa del Flujo',
      workflow_progress: 'Progreso del flujo',
      report_ready: 'Informe listo',
      decisions: 'Decisiones',
      clear_filter: 'Limpiar filtro',
      items: 'elementos',
      opportunities: 'oportunidades',
      from_insight: 'de perspectiva de mercado',
      pre_meeting_date: 'Fecha de reunión pre-comité',
      post_meeting_date: 'Fecha de reunión post-comité',
      view_details: 'Ver Detalles',
    },
    statusLabel: 'Estado',
    report_button: {
      pre: 'Informe pre-comité',
      post: 'Informe post-comité',
      download_pre: 'Descargar Pre-Informe',
      download_post: 'Descargar Post-Informe',
      regenerate: 'Regenerar informe',
    },
    solutionsLabel: 'Soluciones',
    solutionCount_one: '{{count}} solución',
    solutionCount_other: '{{count}} soluciones',
    solutionCount: '{{count}} soluciones',
    viewProjectLead: 'Project lead',
    solutionsHeading: 'Soluciones',
    opportunitiesSubtitle:
      'Vota oportunidades y soluciones. Las notas se guardan automáticamente.',
    noOpportunitiesYet: 'Aún no hay oportunidades en este comité.',
    noSolutionsYet: 'Aún no hay soluciones. Añade una o ejecuta el generador.',
    actions: {
      addSolution: 'Añadir solución',
      generateSolutions: 'Generar soluciones…',
      editOpportunity: 'Editar oportunidad',
      editSolution: 'editar solución',
      removeFromCommittee: 'Quitar del comité',
    },
    panels: {
      editOpportunity: 'editar oportunidad',
      addSolution: 'nueva solución',
    },
    close: {
      button: 'Cerrar comité',
      alreadyClosed: 'comité cerrado',
      inPostCommittee: 'en post-comité',
      title: 'Cerrar comité',
      description:
        'Cerrar el comité disparará la generación de un Project Lead para cada oportunidad aprobada. Esta acción es irreversible.',
      confirmButton: 'Cerrar comité',
      checkPreReport: 'Informe pre-comité generado',
      checkPostReport: 'Informe post-comité generado',
      checkTranscript: 'Transcripción cargada y acta generada',
      approvedOpportunitiesLabel: 'Oportunidades aprobadas',
      noApprovedYet:
        'Aún no se ha aprobado ninguna oportunidad — el cierre no producirá artefactos.',
      warning:
        'Esto cerrará el comité y disparará la generación de Project Lead para cada oportunidad aprobada. Es irreversible.',
      processing: 'Generando artefactos…',
    },
  },

  project: {
    tabs: {
      solutions: 'Soluciones',
      strategy: 'Estrategia',
      clients: 'Clientes',
      assets: 'Activos',
    },
    title: 'Proyectos',
    subtitle: 'Gestionar oportunidades validadas como proyectos',
    new_project: 'Nuevo Proyecto',
    edit_project: 'Editar Proyecto',
    no_projects: 'No se encontraron proyectos',
    back_to_list: 'Volver a Proyectos',
    not_found: 'Proyecto no encontrado',
    search_placeholder: 'Buscar proyectos...',
    delete_confirm: '¿Está seguro de que desea eliminar este proyecto?',
    deleted: 'Proyecto eliminado',
    deleted_description: 'El proyecto ha sido eliminado exitosamente.',
    delete_error: 'Error al eliminar proyecto',
    created: 'Proyecto creado',
    created_description: 'El proyecto ha sido creado exitosamente.',
    create_error: 'Error al crear proyecto',
    updated: 'Proyecto actualizado',
    updated_description: 'El proyecto ha sido actualizado exitosamente.',
    update_error: 'Error al actualizar proyecto',
    archive: 'Archivar',
    status: {
      all: 'Todos los Estados',
      draft: 'Borrador',
      published: 'Publicado',
      published_flag: 'Publicado (flag)',
      withApplicants: 'Con candidatos',
      closed: 'Archivado',
      completed: 'Completado',
      idea: 'Idea',
      validation: 'Validación',
      committee: 'Comité',
      active: 'Activo',
      archived: 'Archivado',
      legacy: 'Legado',
      inProgress: 'En progreso',
      standby: 'En espera',
      discarded: 'Descartado',
      readyToDeploy: 'Listo para desplegar',
      deployed: 'Desplegado',
    },
    statusReason: {
      prompt: '¿Por qué estás estableciendo este estado?',
      placeholder: 'Motivo…',
    },
    deploy: {
      cta: 'Desplegar',
      confirmTitle: '¿Desplegar este proyecto?',
      confirmBody: 'Esto marca el proyecto como desplegado. Desplegado es definitivo — el estado no se podrá cambiar después.',
    },
    strategy: {
      title: 'estrategia',
      autosaveHint: 'Se guarda automáticamente al salir del campo',
      placeholder: 'Escribe la estrategia de este proyecto: posicionamiento, diferenciadores, prioridades, riesgos…',
    },
    sections: {
      basic: 'A) Información Básica',
      detail: 'B) Detalle Briefing de Proyecto',
      milestones: 'Hitos',
      targeting: 'C) Segmentación',
      scoring: 'D) Puntuación',
      publication: 'E) Publicación',
    },
    startupContacts: {
      title: 'Contacto con Startups',
      description:
        'Seguimiento del contacto manual con las startups surgidas de las hipótesis aprobadas. El estado se actualiza a medida que avanzan las conversaciones.',
      addFromList: 'Añadir desde la lista',
      addNew: 'Añadir nueva',
      addNewDisabledHint: 'La incorporación de startups nuevas llegará pronto',
      pickerTitle: 'Añadir startup desde la lista de candidatas',
      pickerTitleScoped: 'Añadir startup a "{{title}}"',
      pickerDescription:
        'Las candidatas son las startups fijadas en las hipótesis aprobadas de este proyecto. Las ya añadidas se filtran automáticamente.',
      pickerDescriptionScoped:
        'Las candidatas son las startups fijadas a esta solución. Las ya añadidas se filtran automáticamente.',
      searchPlaceholder: 'Buscar candidatas...',
      noCandidates: 'No hay startups candidatas disponibles.',
      noMatches: 'Ninguna candidata coincide con tu búsqueda.',
      addSuccess: 'Se añadieron {{count}} startup(s)',
      addFailed: 'No se pudieron añadir {{count}} startup(s)',
      empty: 'Aún no hay startups asociadas. Usa "Añadir desde la lista" para incorporarlas desde las hipótesis aprobadas.',
      notesPlaceholder: 'Notas de la conversación...',
      contactedAt: 'Primer contacto',
      showExcluded: 'Mostrar excluidas ({{count}})',
      hideExcluded: 'Ocultar excluidas ({{count}})',
      status: {
        does_not_exist: 'No existe',
        pending_contact: 'Sin contactar',
        negotiating: 'En negociación',
        agreed: 'Confirmada',
        dropped: 'Descartada',
      },
    },
    startupKanban: {
      title: 'contacto con startups.',
      description:
        'Agrupado por solución. Arrastra una startup por el tablero a medida que avanza la conversación — el estado se guarda al instante.',
      empty: 'Aún no hay startups. Usa "Añadir desde la lista" para incorporarlas desde las soluciones aprobadas.',
      drag: 'Arrastra para cambiar el estado',
      toggleNotes: 'Notas',
      discard: 'Descartar',
      restore: 'Restaurar',
    },
    fields: {
      title: 'Título del Proyecto',
      sector: 'Sector',
      status: 'Estado',
      short_description: 'Descripción Corta',
      problem_context: 'Problema / Contexto',
      solution_proposal: 'Solución Propuesta',
      scope_deliverables: 'Alcance y Entregables',
      estimated_duration: 'Duración Estimada',
      target_roles: 'Roles Objetivo',
      seniority_min: 'Antigüedad Mínima (años)',
      is_published: 'Publicar Proyecto',
      project_type: 'Tipo de Proyecto',
      vertical: 'Vertical',
      years: 'años',
      publish_description: 'Los proyectos publicados son visibles para emprendedores y activan la búsqueda de coincidencias',
    },
    seniority_scale: {
      entry: 'Junior',
      five: '5 años',
      ten: '10 años',
      fifteen: '15+ años',
    },
    scoring: {
      urgency: 'Urgencia',
      difficulty: 'Dificultad',
      priority_score: 'Puntuación de Prioridad',
      bucket: 'Categoría',
    },
    generate: {
      button: 'Generar Proyectos',
      generating: 'Generando...',
      success: 'Proyectos Generados',
      success_description: '{{count}} proyectos creados desde soluciones aprobadas',
      error: 'Error al generar proyectos',
    },
    stats: {
      total: 'Total',
      published: 'Publicados',
      withApplicants: 'Con Aplicantes',
      closed: 'Cerrados',
      timeToPublish: 'Time-To-Publish',
      timeToPublishDesc: 'Tiempo promedio desde la creación hasta la publicación',
      timeToFirstApplicant: 'Time-To-First-Applicant',
      timeToFirstApplicantDesc: 'Tiempo promedio desde la publicación hasta la primera aplicación',
      timeToClose: 'Time-To-Close',
      timeToCloseDesc: 'Tiempo promedio desde la creación hasta el cierre',
      timeToApplicant: 'Tiempo Medio Aplicante',
    },
    buckets: {
      all: 'Todos los Buckets',
      quickWin: 'Quick Win',
      strategicBet: 'Apuesta Estratégica',
      maintain: 'Mantener',
      defer: 'Diferir',
    },
    filters: {
      statusFilter: 'Filtro de Estado',
      priorityBucket: 'Bucket de Prioridad',
      clearFilters: 'Limpiar filtros',
    },
    actions: {
      viewDetails: 'Ver Detalles',
      edit: 'Editar',
      delete: 'Eliminar',
      save: 'Guardar Cambios',
      findEntrepreneurs: 'Buscar Emprendedores',
    },
    list: {
      assets: 'Assets',
      assetsGenerated: 'generados',
      assetsMissing: 'sin generar',
      clients: 'Clientes',
      priority: 'Prioridad:',
      created: 'Creado',
      items: 'elementos',
      errorLoading: 'Error al cargar proyectos: {{message}}',
    },
    matching: {
      confirm: '¿Buscar emprendedores compatibles con "{{title}}"? Esto puede actualizar coincidencias existentes.',
      distribution: 'Distribución de Calidad de Coincidencias',
      sort: 'Ordenar',
      sortScore: 'Puntuación',
      sortName: 'Nombre',
      sortStarredScore: 'Destacados + Puntuación',
      sortStarredName: 'Destacados + Nombre',
      applications: 'Postulaciones',
      noApplications: 'Sin postulaciones aún.',
      applicationsHint: 'Los emprendedores que se postulen aparecerán aquí.',
      allMatches: 'Todas las Coincidencias',
      noMatches: 'No se encontraron coincidencias para este proyecto.',
      publishHint: 'Publique el proyecto para activar la búsqueda de emprendedores.',
      allApplied: 'Todos los emprendedores coincidentes se han postulado.',
      preview: {
        title: 'Emprendedores Compatibles',
        publishRequired: 'Publique este proyecto para encontrar emprendedores compatibles',
        matching: 'Buscando...',
        refreshMatches: 'Actualizar',
        runMatching: 'Buscar Coincidencias',
        noMatches: 'Sin coincidencias aún. Haga clic en "Buscar Coincidencias" para buscar emprendedores.',
        showing: 'Mostrando {{shown}} de {{total}} coincidencias',
      },
      dialog: {
        confirmTitle: 'Buscar Emprendedores Compatibles',
        existingMatchesWarning: 'Las coincidencias existentes serán eliminadas y reemplazadas',
        startMatching: 'Iniciar Búsqueda',
        matchingTitle: 'Buscando Emprendedores',
        matchingDescription: 'Buscando y puntuando candidatos...',
        pleaseWait: 'Esto puede tomar un momento. Por favor espere...',
        successTitle: 'Búsqueda Completada',
        successDescription: 'Se encontraron emprendedores compatibles exitosamente.',
        matchesFound: 'emprendedores compatibles',
        viewMatches: 'Ver Coincidencias',
        errorTitle: 'Búsqueda Fallida',
        errorDescription: 'Ocurrió un error al buscar coincidencias.',
        retry: 'Reintentar',
      },
    },
    publishDialog: {
      title: 'Confirmar Publicación',
      description: 'Revisa los criterios de segmentación antes de publicar. Los proyectos publicados son visibles para emprendedores y activan la búsqueda de coincidencias.',
      confirm: 'Publicar y Buscar Coincidencias',
    },
  },

  agentProcessing: {
    defaultProcessing: 'Procesando su solicitud...',
    defaultCompleted: '¡Operación completada exitosamente!',
    defaultError: 'Ocurrió un error. Por favor intente de nuevo.',
    tryAgain: 'Intentar de Nuevo',
    pleaseWait: 'Por favor espere, esto puede tomar unos momentos...',
    completed: 'Completado',
    error: 'Error',
    minimize: 'Minimizar',
  },

  backgroundTask: {
    completed: 'Completado',
    failed: 'Fallido',
    clickToView: 'Clic para ver',
    processing: 'Procesando',
    runningInBackground: 'Ejecutando en segundo plano',
    unknownError: 'Error desconocido',
    taskFailed: 'La tarea en segundo plano falló',
    taskLost: 'Se perdió la tarea en segundo plano',
  },

  solution: {
    bands: {
      aligned: 'Startups alineadas',
      suggestions: 'Sugerencias',
      noneAligned: 'No existen startups 100% alineadas con la solución, quizás te puedan interesar estas.',
    },
    aiContext: 'Datos adicionales',
    generatingReport: 'Generando Informe de Solución',
    generatingReportDescription: 'Buscando startups coincidentes y analizando ajuste...',
    searchingStartups: 'Buscando y analizando startups chinas...',
    reportGenerated: '¡Informe generado exitosamente!',
    regenerateReport: 'Regenerar Informe',
    generateReport: 'Generar Informe',
    reportReady: 'Informe Listo',
    devalidate: 'Quitar de aprobación pendiente',
    validate: 'Validar',
    details: 'Detalles de Solución',
    technology: 'Tecnología',
    operation: 'Operación',
    scope: 'Alcance',
    businessModel: 'Modelo de Negocio',
    solutionScore: 'Puntuación de Solución',
    matchingStartups: 'Startups Coincidentes',
    panels: {
      editSolution: 'editar solución',
    },
    documentView: {
      selectedStartups: 'Startups seleccionadas',
      problem: 'P',
      solution: 'S',
      transferability: 'T',
      problemFull: 'Ajuste al problema',
      solutionFull: 'Ajuste de solución',
      transferabilityFull: 'Transferibilidad',
      overall: 'Ajuste global',
      addNewStartup: 'Añadir nueva startup',
    },
    searched: 'buscados',
    analyzed: 'analizados',
    noStartupsFound: 'No se encontraron startups coincidentes',
    noReportYet: 'Aún no se ha generado informe',
    clickGenerateReport: 'Haz clic en "Generar Informe" para buscar startups chinas coincidentes',
    overall: 'General',
    problemFit: 'Ajuste de Problema',
    solutionFit: 'Ajuste de Solución',
    transferability: 'Transferibilidad',
    keyEvidence: 'Evidencia Clave',
    problemFitAnalysis: 'Análisis de Ajuste de Problema',
    solutionFitAnalysis: 'Análisis de Ajuste de Solución',
    transferabilityAnalysis: 'Análisis de Transferibilidad',
    onepagerData: 'Onepager de Startup',
    identity: 'Identidad',
    valueProposition: 'Propuesta de Valor',
    marketPosition: 'Posición de Mercado',
    businessModelBlock: 'Modelo de Negocio',
    teamIp: 'Equipo e IP',
    contact: 'Contacto y Alianzas',
    evidence: 'Evidencia',
    startupReference: 'Referencia de Startup',
    opportunityAlignment: 'Alineación con Oportunidad',
    scoreBreakdown: 'Desglose de Puntuación',
    role: 'Rol',
    proof: 'Evidencia',
    problem: 'Problema',
    icp: 'PCI',
    constraintsAddressed: 'Restricciones Abordadas',
  },

  editor: {
    markdownField: 'Notas',
    expand: 'Ampliar',
    autosavesOnBlur: 'Guarda automáticamente al salir',
    characterCount: '{{count}} caracteres',
  },

  projectDocuments: {
    title: 'Documentación generada',
    subtitle: 'Documentos que la plataforma redacta a partir de los datos del proyecto.',
    brief: 'Briefing de proyecto',
    briefDescription:
      'Documento completo para inversores y stakeholders: el problema, la evidencia, el enfoque propuesto y lo que queda abierto.',
    profile: 'Ficha de proyecto',
    profileDescription:
      'Versión de dos páginas del briefing, para emprendedores y builders.',
    brochure: 'Brochure',
    brochureDescription:
      'Imagen de una página maquetada sobre la imagen de marca, para compartir el proyecto de un vistazo.',
    availableIn: 'Disponible en {{langs}}',
    noneYet: 'Aún no se ha generado documentación.',
    generatedMeta: 'Última generación · {{date}}',
    downloadBranding: 'Descargar imagen de marca',
    generate: 'Generar documentación',
    regenerate: 'Regenerar documentación',
    generatingTitle: 'Generando documentación',
    generatingDesc:
      'Redactando el briefing y maquetando la ficha y el brochure a partir de él.',
    working: 'Generando la documentación…',
    brandImage: 'Imagen de marca',
    uploadImage: 'Subir imagen',
    brandReuseHint: 'Déjalo vacío para reutilizar la última imagen de marca subida.',
    brandRequiredHint:
      'Hace falta una imagen de marca: el brochure se maqueta sobre ella.',
    regenerateHint:
      'Regenerar reemplaza los documentos guardados en todos los idiomas.',
    allLanguagesHint:
      'Los tres documentos se generan en inglés. Elige otro idioma en el menú de descarga de cada documento para traducirlo y guardarlo en caché bajo demanda.',
  },

  comments: {
    title: 'Comentarios',
    add: 'Añadir comentario',
    placeholder: 'Escribe un comentario…',
    empty: 'Aún no hay comentarios.',
    loading: 'Cargando comentarios…',
    itemType: 'comentario',
  },

  documents: {
    preparing: 'Preparando el documento...',
    rendering: 'Generando este idioma...',
    downloading: 'Descargando...',
  },
  common: {
    dateTime: {
      datePlaceholder: 'Elige una fecha',
      timePlaceholder: 'Elige una hora',
      timezoneNoteBrowser: 'Las horas son de tu zona horaria',
    },
    select: 'Selecciona',
    expand: 'Ampliar',
    collapse: 'Contraer',
    pickerCreateHint:
      'no está en la lista — créala desde cero y su perfil se generará automáticamente',
    pickerCreateBadge: 'nueva entrada',
    backToResults: 'Volver a los resultados',
    add_n: 'Añadir ({{count}})',
    n_selected: '{{count}} seleccionados',
    select_all: 'Seleccionar todos',
    select_none: 'Quitar selección',
    created: 'Creado',
    hide: 'Ocultar',
    lastUpdated: 'Última Actualización',
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
    saving: 'Guardando...',
    working: 'Trabajando...',
    generateWithAI: 'Generar con IA',
    update: 'Actualizar',
    items: 'elementos',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    approve: 'Aprobar',
    reject: 'Rechazar',
    report: 'Informe',
    generate_report: 'Generar Informe',
    validate: 'Validar',
    devalidate: 'Quitar de aprobación pendiente',
    error: 'Error',
    backTo: 'Volver a {{name}}',
    noDataAvailable: 'Sin Datos Disponibles',
    sections: 'secciones',
    sources: 'fuentes',
    expandAll: 'Expandir todo',
    collapseAll: 'Colapsar todo',
    back: 'Volver',
    unknown: 'Desconocido',
    close: 'Cerrar',
    generate: 'Generar',
    remove: 'Eliminar',
    showLess: 'Mostrar menos',
    showMore: 'Mostrar más',
    title: 'Título',
    add: 'Agregar',
    unknown_error: 'Error desconocido',
    process: 'Procesar',
    processing: 'Procesando...',
    generating: 'Generando...',
    export: 'Exportar',
    upload: 'Subir',
    refresh: 'Actualizar',
    copy: 'Copiar',
    open: 'Abrir',
    filters: 'Filtros',
    submit: 'Enviar',
    submitting: 'Enviando...',
    optional: '(opcional)',
    unlink: 'Desvincular',
    searchMarketInsights: 'Buscar perspectivas de mercado...',
  },


  units: {
    days: 'días',
    months: 'mes',
    cases: 'casos',
    practices: 'prácticas',
    sources: 'fuentes',
    integrations: 'integraciones',
  },

  labels: {
    target: 'Objetivo',
    delta: 'Delta',
    ttv: 'TTV',
  },

  stats: {
    score: 'Puntuación',
    solutions: 'Soluciones',
    ttv: 'TTV',
    payback: 'Retorno',
    files: 'Archivos',
    opportunities: 'Oportunidades',
    solutionLines: 'Líneas de Solución',
    references: 'Referencias',
    icp: 'PCI',
    kpi: 'KPI',
    urgency: 'Urgencia',
  },

  tooltips: {
    scoreTooltip: 'Puntuación general basada en ajuste, viabilidad y potencial',
    solutionsTooltip: 'Número de soluciones para esta tesis',
    ttvTooltip: 'Tiempo estimado para obtener valor en días',
    paybackTooltip: 'Período de retorno estimado en meses',
    filesUploaded: 'Documentos cargados para análisis',
    opportunitiesIdentified: 'Oportunidades de inversión identificadas del análisis',
    solutionLinesCreated: 'Líneas de solución (tesis) creadas para oportunidades',
    referencesTooltip: 'Referencias externas y citas del informe',
    icpDefined: 'Perfil de Cliente Ideal definido',
    kpiTooltip: 'KPI actual del problema',
    urgencyTooltip: 'Puntuación de urgencia de mercado',
    solutionsDefined: 'Líneas de solución definidas para esta oportunidad',
    marketUrgency: 'Urgencia de Mercado',
    timeSensitivity: 'Sensibilidad temporal de esta oportunidad',
    totalInsights: 'Número total de perspectivas de mercado creadas',
    draftInsights: 'Perspectivas creadas pero aún no procesadas',
    processingInsights: 'Perspectivas actualmente siendo analizadas por IA',
    runningInsights: 'Perspectivas actualmente siendo analizadas por IA',
    completedInsights: 'Análisis completo, informe disponible',
    failedInsights: 'La última ejecución falló; no se generó informe',
    validatedInsights: 'Perspectivas revisadas y validadas',
    withOpportunities: 'Perspectivas que han extraído oportunidades',
  },

  overview: {
    totalInsights: 'Total Perspectivas',
    draft: 'Borrador',
    processing: 'Ejecutando',
    running: 'Ejecutando',
    validated: 'Completado',
    completed: 'Completado',
    failed: 'Fallido',
    hoverForDetails: 'Pasa el cursor sobre los indicadores para ver detalles',
    dataProgress: 'Progreso de datos: Archivos → Informe',
    validatedStatus: 'Validado',
    marketWindow: 'Ventana de Mercado',
    urgency: 'urgencia',
    constraints: 'Restricciones',
    data: 'Datos',
    compliance: 'Cumplimiento',
    it: 'TI',
    successObjective: 'Objetivo de Éxito',
    targetKpi: 'KPI Objetivo',
    expectedImprovement: 'Mejora Esperada',
    benchmarkGap: 'Brecha de Referencia',
    notableCases: 'Casos Notables',
    gapComparison: 'Comparación de Brecha',
    saveMinutes: 'Guardar Actas',
    generatingPostReport: 'Generando Informe Post-Comité',
    problem: 'Problema',
    targetIcp: 'ICP Objetivo',
    keyRoles: 'Roles clave',
    ttv: 'TTV',
    payback: 'Recuperación',
    solutionLine: 'línea de solución',
    solutionLines: 'líneas de solución',
    solutions: 'soluciones',
    unsavedChanges: 'Tiene cambios sin guardar',
    competition: 'Competencia',
    valueProposition: 'Propuesta de Valor',
    marketSize: 'Tamaño de Mercado',
    risks: 'Riesgos',
    size: 'Tamaño',
    kpi: 'KPI',
    chinaBenchmark: 'Benchmark China',
    problemStatement: 'Planteamiento del problema',
  },

  risks: {
    technical: 'técnicos',
    operational: 'operacionales',
    market: 'mercado',
    mitigations: 'mitigaciones',
    barriersIdentified: '{{count}} barreras identificadas',
    strategiesDefined: '{{count}} estrategias definidas',
    similarCases: 'casos similares',
    payback: 'retorno',
  },

  urgencyLevels: {
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    critical: 'Crítica',
  },

  renameDialog: {
    title: 'Editar nombre',
    description: 'Escribe el nuevo nombre y guarda.',
  },
  validation: {
    required: 'Este campo es obligatorio',
    minValue: 'Debe ser al menos {{min}}',
    maxValue: 'Debe ser como máximo {{max}}',
  },

  evaluation: {
    title: 'Evaluación de Oportunidades',
    subtitle: 'Enruta las oportunidades aprobadas hacia iniciativas de proyecto.',
    approved: 'Oportunidades Aprobadas',
    approve: 'Aprobar',
    reject: 'Rechazar',
    sendToShaping: 'Enviar a Modelado',
    queued: 'En Cola de Revisión',
    urgency: 'Urgencia',
    urgent: 'Urgente',
    fit: 'Ajuste Estratégico',
    sponsor: 'Patrocinador',
    solutionsLabel: 'Soluciones',
    unassigned: 'Sin asignar',
    solutions_one: '{{count}} solución',
    solutions_other: '{{count}} soluciones',
    empty: 'Aún no hay oportunidades aprobadas para este comité.',
    approvedToast: 'Oportunidad aprobada',
    rejectedToast: 'Oportunidad rechazada',
    sentToast: 'Aprobada — abriendo modelado',
    failed: 'La acción falló',
  },
  shaping: {
    title: 'Modelado',
    subtitle: 'Agrupa oportunidades aprobadas en iniciativas de proyecto',
    inbox: 'Bandeja / Sin asignar',
    newLead: 'Nuevo Contenedor',
    createLeadTitle: 'Nueva Iniciativa de Proyecto',
    createLeadDesc: 'Crea un contenedor de modelado para oportunidades aprobadas.',
    name: 'Nombre',
    namePlaceholder: 'p. ej. Estrategia de Expansión Global Q3',
    objective: 'Objetivo Central',
    objectivePlaceholder: '¿Hacia qué está modelando esta iniciativa?',
    sector: 'Sector',
    create: 'Crear',
    creating: 'Creando…',
    noMatches: 'Ninguna oportunidad coincide con tu búsqueda.',
    dropHint: 'Agrega oportunidades para fusionarlas en esta iniciativa',
    mergeDropHint: 'Arrastra oportunidades aquí para fusionarlas en {{title}}',
    activeContainer: 'Contenedor activo',
    constituents: 'Oportunidades Constituyentes',
    solutions_one: '{{count}} solución',
    solutions_other: '{{count}} soluciones',
    opportunities_one: '{{count}} oportunidad',
    opportunities_other: '{{count}} oportunidades',
    noLeads: 'Aún no hay iniciativas de proyecto. Crea una para empezar a modelar.',
    emptyLead: 'Aún no hay oportunidades.',
    unassignedEmpty: 'No hay oportunidades aprobadas sin asignar.',
    remove: 'Quitar de la iniciativa',
    view: 'Abrir iniciativa',
    mergeReadiness: 'Preparación de Fusión',
    generateOnePager: 'Generar One-Pager',
    deleteLead: 'Eliminar iniciativa',
    createdToast: 'Iniciativa de proyecto creada',
    deletedToast: 'Iniciativa de proyecto eliminada',
    deleteLeadFailed: 'No se pudo eliminar la iniciativa de proyecto',
    addFailed: 'No se pudo agregar la oportunidad',
    moveTo: 'Mover a iniciativa',
    moveToNew: 'Nueva iniciativa con esta',
    movedToast: 'Movida a la iniciativa',
    viewOpportunity: 'Ver oportunidad',
    notFound: 'Iniciativa de proyecto no encontrada',
    regenerate: 'Regenerar',
    exportPdf: 'Exportar PDF',
    exportImage: 'Exportar Imagen',
    onePager: 'One-Pager',
    onePagerEmpty: 'Aún no hay one-pager — genéralo desde la cabecera.',
    onePagerReady: 'One-pager listo',
    committeeFeedback: 'Feedback del comité',
    editOpportunity: 'Editar oportunidad',
    editSolution: 'Editar solución',
    viewSolution: 'Abrir solución',
    referenceCases: 'Casos de referencia',
    addSolution: 'Añadir solución',
    solutionItemType: 'solución',
    createSolutionTitle: 'Creando solución',
    createSolutionDesc: 'La IA está generando la solución completa a partir de tu entrada…',
    createSolutionFailed: 'No se pudo crear la solución',
    generateSolutions: 'Generar soluciones',
    generatingSolutions: 'Generando soluciones',
    generatingSolutionsDesc: 'La IA está generando soluciones para esta oportunidad…',
    generateSolutionsFailed: 'No se pudieron generar las soluciones',
    technicalSpecs: 'Especificaciones técnicas',
    downloadPdf: 'Descargar PDF',
    specPdf: {
      generating: 'Generando PDF',
      generatingDesc: 'Traduciendo y generando la ficha…',
    },
    technicalSpecsPlaceholder: 'Añade especificaciones técnicas (texto libre)',
    technicalSpecsExpandedPlaceholder: 'Escribe aquí las especificaciones técnicas…',
    onePagerGeneratedAt: 'Generado el {{date}}',
    onePagerGenerating: {
      title: 'Generando one-pager',
      desc: 'Componiendo el texto y creando el one-pager visual de este lead.',
      status: 'Generando one-pager...',
    },
    finalized: 'Finalizado',
    finalize: 'Aprobar y Crear Proyecto',
    finalizeConfirm: '¿Aprobar este lead? Crea un proyecto con los datos del lead, listo para gestionar el contacto con startups y los recursos. El lead queda bloqueado.',
    finalizeAction: 'Aprobar',
    finalizedToast: 'Aprobado — proyecto creado',
    finalizeFailed: 'No se pudo aprobar la iniciativa de proyecto',
    reject: 'Rechazar',
    rejectConfirm: '¿Rechazar este lead de proyecto? Se archivará.',
    rejectedToast: 'Lead de proyecto rechazado',
    lifecycle: {
      opportunity: 'Oportunidad',
      committee: 'Comité',
      lead: 'Lead de Proyecto',
      project: 'Proyecto',
    },
    viewProject: 'Ver Proyecto',
    solutions: {
      empty:
        'Este proyecto aún no tiene oportunidades. Aparecen cuando el proyecto se materializa desde su lead.',
    },
    assets: {
      title: 'Activos de Apoyo',
      upload: 'Subir',
      empty: 'Aún no hay activos de apoyo.',
      emptyFolder: 'Esta carpeta está vacía — arrastra archivos aquí para subirlos.',
      delete: 'Eliminar activo',
      deleteFolder: 'Eliminar carpeta',
      deleteFolderConfirm: '¿Eliminar "{{name}}" y todo su contenido?',
      dropToFolder: 'Suelta los archivos para subirlos a «{{folder}}»',
      dragHint: 'Arrastra documentos a esta zona para subirlos, o usa «Subir».',
      uploadQueue: {
        running: 'Subiendo… {{done}} de {{total}}',
        finished: '{{done}} subidos · {{failed}} con error',
        clear: 'Limpiar',
        dismiss: 'Quitar de la lista',
      },
      uploadErrors: {
        tooLarge: 'El archivo es demasiado grande para subirlo.',
        interrupted: 'La subida se ha interrumpido (conexión lenta o archivo muy grande). Vuelve a intentarlo.',
      },
      deletedToast: 'Activo eliminado',
      uploadFailed: 'Error al subir',
      moveTo: 'Mover a carpeta',
      rootFolder: 'Raíz',
      preview: 'Vista previa',
      selectToPreview: 'Selecciona un archivo para previsualizarlo aquí.',
      noInlinePreview: 'Sin vista previa para este tipo de archivo.',
      previewFailed: 'No se pudo cargar la vista previa.',
      uploadTarget: 'Subiendo a',
      newFolder: 'Nueva carpeta',
      folderName: 'nombre de carpeta',
    },
    voucher: 'Voucher Visual',
    generateVoucher: 'Generar Voucher',
    voucherEmpty:
      'Genera un one-pager totalmente visual. Las imágenes subidas se usan como referencias de marca para el visual principal.',
    voucherHeroAlt: 'Visual principal del voucher',
    voucherGenerating: {
      title: 'Generando voucher',
      desc: 'Componiendo el texto, creando el visual principal y renderizando el PDF.',
      status: 'Generando voucher...',
    },
    outreach: {
      title: 'Contacto con Startups',
      empty:
        'Registra qué startups han sido contactadas para este lead. Iniciar el contacto prepara el proyecto borrador y carga las startups candidatas de las soluciones aprobadas.',
      start: 'Iniciar Contacto',
      readyToast: 'El contacto con startups está listo',
    },
    startups: {
      title: 'Startups',
      label: 'Startups / Socios',
      add: 'Añadir startup',
      itemType: 'startup',
      empty:
        'Inicia el contacto para gestionar startups de este lead — añade startups existentes o nuevas (dealflow + 2DS + one-pager).',
    },
    assembly: {
      solutionsHeading: 'Soluciones',
      noSolutions: 'Aún no hay soluciones.',
      assign: 'Asignar',
      assignTo: 'Asignar a Iniciativa de Proyecto',
      prev: 'Anterior',
      next: 'Siguiente',
      toAssign: '{{count}} por asignar',
      assignedSummary: '{{assigned}} en {{leads}} iniciativas',
      close: 'Cerrar post-comité',
      closeHint: '{{count}} aún por asignar',
      closedToast: 'Post-comité completado',
      assigned: 'Asignada',
      assignedTo: 'Asignada a {{lead}}',
      unassign: 'Quitar',
    },
    split: {
      title: 'Dividir Project Lead',
      action: 'Dividir',
      cta: 'Dividir',
      desc: 'Asigna las soluciones de "{{title}}" en iniciativas hijas separadas.',
      dndDesc: 'Arrastra soluciones al nuevo lead. El lead original conserva lo que quede a la izquierda.',
      keepBox: 'El lead original conserva',
      moveBox: 'Nuevo lead',
      newName: 'Nombre del nuevo lead',
      needTwo: 'Un lead necesita al menos dos soluciones para dividirse.',
      targets: 'Estructura Objetivo',
      addTarget: 'Agregar Objetivo',
      solutions: 'Soluciones Disponibles',
      unassigned: 'Sin asignar',
      noSolutions: 'No hay soluciones aprobadas para asignar.',
      confirm: 'Confirmar División',
      needAllocation: 'Asigna al menos una solución a un objetivo.',
      done: 'Dividida en una nueva oportunidad',
      failed: 'No se pudo dividir la oportunidad',
    },
    merge: {
      action: 'Fusionar',
      title: 'Fusionar Project Leads',
      dndDesc: 'Combina dos project leads del mismo sector en uno. Todas las oportunidades y soluciones pasan al nuevo lead, y el otro se elimina.',
      pickSecond: 'Selecciona un lead para fusionar',
      result: 'Nuevo project lead',
      noCandidates: 'No hay otros leads en borrador del mismo sector para fusionar.',
      confirm: 'Fusionar',
      done: 'Project leads fusionados',
      failed: 'No se pudieron fusionar los project leads',
    },
    archives: {
      title: 'Archivos',
      subtitle: 'Iniciativas de proyecto finalizadas',
      empty: 'Aún no hay iniciativas de proyecto finalizadas.',
      view: 'Ver',
    },
    lineage: {
      split: 'Dividida',
      merged: 'Fusionada',
    },
    assignHint: 'Arrastra sobre una iniciativa de proyecto para asignar',
    postCommittee: {
      title: 'Post-Comité',
      subtitle: 'Revisa un comité cerrado y modela sus oportunidades en iniciativas',
      workspaceSubtitle: 'Agrupa, divide y asigna las oportunidades de este comité en iniciativas de proyecto',
      assembleSubtitle: 'Divide, fusiona y asigna oportunidades aprobadas en iniciativas de proyecto',
      committee: 'Comité',
      pick: 'Selecciona comité',
      reviewHeading: 'Revisión',
      shapeHeading: 'Modelar en Iniciativas de Proyecto',
      empty: 'Aún no hay comités listos para la revisión post-comité.',
    },
    projectLeads: {
      title: 'Iniciativas de Proyecto',
      subtitle: 'Todos los contenedores de modelado entre comités',
      empty: 'Aún no hay iniciativas de proyecto. Créalas desde un espacio post-comité.',
      noMatches: 'No se encontraron iniciativas de proyecto',
      searchPlaceholder: 'Buscar iniciativas de proyecto…',
      count_one: '{{count}} elemento',
      count_other: '{{count}} elementos',
      view: 'Ver',
      filter: {
        all: 'Todos',
      },
      status: {
        inProgress: 'En progreso',
        standby: 'En espera',
        discarded: 'Descartado',
        convertedToProject: 'Convertido a Proyecto',
      },
    },
    statusReason: {
      label: 'Motivo',
      prompt: '¿Por qué estableces este estado?',
      placeholder: 'Motivo…',
    },
    opp: {
      new: 'Nueva Oportunidad',
      title: 'Nueva Oportunidad',
      desc: 'Crea una oportunidad aprobada, lista para asignar durante el modelado.',
      name: 'Título',
      namePlaceholder: 'p. ej. Mantenimiento predictivo de turbinas',
      vertical: 'Vertical',
      verticalPlaceholder: 'Industria / vertical (opcional)',
      createdToast: 'Oportunidad creada',
      failed: 'No se pudo crear la oportunidad',
    },
  },
  startups: {
      noUpdates: 'Sin actualizaciones',
      pendingNew_other: '{{count}} nuevas',
      pendingNew_one: '{{count}} nueva',
      taskOpportunityTitle: 'Oportunidad: {{name}}',
      errorLoading: 'Error al cargar startups: {{message}}',
    pageTitle: 'Inteligencia de Startups',
    subtitle: 'Perfiles de empresas estructurados con insights extraídos por IA',
    backToStartups: 'Volver a Startups',
    startupNotFound: 'Startup no encontrada',
    noDataYet: 'Esta startup aún no tiene datos de análisis.',
    processingStatus: 'Procesando',
    scopedBy: 'filtrado por',
    allSectors: 'todos los sectores',
    scopeBySector: 'Filtrar por sector',
    scoreDetails: 'Detalle de puntuación',
    scoreBreakdown: 'Desglose de puntuación',
    scoreFormula: 'Fórmula',
    noScoreBreakdown: 'No hay desglose por dimensión disponible para esta coincidencia.',
    marketInsightOverallScoreCaption: 'Puntuación final de relevancia (reordenada por IA)',
    rawDimensionScores: 'Similitud semántica bruta por dimensión',
    dimensions: {
      combined: 'Puntuación semántica bruta (sin diferenciar)',
      problem_market: 'Problema y mercado',
      business_execution: 'Negocio y ejecución',
    },
    solutionScoreFormula: 'overall = combinación ponderada de encaje de problema, encaje de solución y transferibilidad (0–100 cada una), puntuadas por el agente de soluciones.',
    toasts: {
      generatingOpportunity: 'Generando oportunidad a partir del onepager…',
      generateOpportunityFailed: 'Error al iniciar la generación',
    },
    stats: {
      totalStartups: 'Total Startups',
      completeProfiles: 'Perfiles Completos',
      simplified: 'Simplificado',
      pending: 'Pendiente',
    },
    filters: {
      profileStatus: 'Estado del Perfil',
      allProfiles: 'Todos los Perfiles',
      allSectors: 'Todos los Sectores',
      industrySector: 'Sector Industrial',
      searchByName: 'Buscar por nombre...',
      showingOf: 'Mostrando {{count}} de {{total}}',
      clear: 'Limpiar',
      noStartupsFound: 'No se encontraron startups',
      clearFilters: 'Limpiar filtros',
    },
    delete: {
      failed: 'No se pudo eliminar la startup',
      processing: 'No se puede eliminar la startup mientras se está procesando.',
      detachWarning: 'Al eliminarla, la startup se quitará de: {{usages}}.',
      usedByOtherOrgs: 'No se puede eliminar: {{count}} registros de otras organizaciones usan esta startup.',
      usage: {
        opportunities: 'oportunidades ({{names}})',
        project_leads: 'project leads ({{names}})',
        projects: 'proyectos ({{names}})',
        other_organizations: '{{count}} registros de otras organizaciones',
      },
    },
    actions: {
        generateOpportunity: 'Generar oportunidad',
      viewProfile: 'Ver Perfil',
      vectorize: 'Vectorizar',
      generateOnepager: 'Generar OnePager',
    },
    vectorizing: {
      title: 'Vectorizando startup',
      desc: 'Extrayendo dimensiones y almacenando vectores para hacer esta startup buscable…',
      status: 'Ejecutando extracción de dimensiones',
    },
    onepagerGenerating: {
      title: 'Generando OnePager',
      desc: 'Construyendo el onepager completo de 6 bloques mediante búsqueda web + LLM…',
      status: 'Ejecutando agente onepager',
    },
    tabs: {
      content: 'Análisis',
      assets: 'Assets',
    },
    badges: {
        noProfile: 'Sin perfil',
      validated: 'Validado',
      draft: 'Borrador',
      inProgress: 'En Progreso',
      failed: 'Fallido',
      completeOnePager: 'One-Pager Completo',
      simplifiedAnalysis: 'Análisis Simplificado',
      currentData: 'Datos Actuales',
      fullAnalysis: 'Análisis Completo',
    },
    contactPerson: {
      title: 'Persona de contacto',
      name: 'Nombre',
      role: 'Rol',
      email: 'Email',
      phone: 'Teléfono',
      empty: 'Aún no hay persona de contacto — añádela con Editar.',
    },
    problemMarket: {
      editTitle: 'Editar problema y solución',
      enrichedContent: 'Resumen',
      whatProblem: 'Qué problema resuelve',
      howItSolves: 'Cómo lo resuelve',
      onePerLine: 'Un elemento por línea',
    },
    sections: {
      simplifiedAnalysis: 'Análisis Simplificado (2D)',
      completeOnePager: 'One-Pager Completo',
      problemMarketAnalysis: 'problema y solución',
      industryVerticals: 'Verticales de industria',
      businessExecutionAnalysis: 'Análisis Negocio-Ejecución',
      companyIdentity: 'Identidad y Estado de la Empresa',
      valueProposition: 'Propuesta de Valor y Solución',
      marketPosition: 'Posición de Mercado y Competencia',
      businessModel: 'Modelo de Negocio',
      teamIp: 'Equipo y Propiedad Intelectual',
      technologyStack: 'Stack Tecnológico',
      contactPartnerships: 'Contacto y Alianzas',
      dataQuality: 'Evaluación de Calidad de Datos',
      references: 'Fuentes de Datos y Referencias',
      linkageSubgraph: 'Subgrafo de Vínculos',
      verification: 'Verificación',
      pipelineMetadata: 'Metadatos del Pipeline',
    },
    verification: {
      sourceValidated: 'Fuente Validada',
      crossReferenced: 'Verificación Cruzada',
      crossReferencedDesc: 'Corroborado en {{count}} fuente(s) externa(s).',
      extractionVerified: 'Extracción Verificada',
    },
    fields: {
      generationModel: 'Modelo de Generación',
      marketUrgency: 'Urgencia de Mercado',
      marketSize: 'Tamaño de Mercado',
      problemSeverity: 'Severidad del Problema',
      revenueStreams: 'Fuentes de Ingresos',
      technologyStack: 'Stack Tecnológico',
      primaryProblem: 'Problema Principal',
      targetMarket: 'Mercado Objetivo',
      painPoints: 'Puntos de Dolor',
      industryVerticals: 'Verticales de Industria',
      geographicalFocus: 'Enfoque Geográfico',
      businessModel: 'Modelo de Negocio',
      fundingStage: 'Etapa de Financiación',
      yearEstablished: 'Año de Fundación',
      keyCustomers: 'Clientes Clave',
      keywords: 'Palabras Clave',
      chineseName: 'Nombre en Chino',
      englishName: 'Nombre en Inglés',
      foundationYear: 'Año de Fundación',
      location: 'Ubicación',
      status: 'Estado',
      registrationCode: 'Código de Registro',
      problemAddressed: 'Problema Abordado',
      solutionFramework: 'Marco de Solución',
      valueProposition: 'Propuesta de Valor',
      productsServices: 'Productos/Servicios',
      industriesServed: 'Industrias Atendidas',
      marketSegment: 'Segmento de Mercado',
      targetCustomer: 'Cliente Objetivo',
      marketTrends: 'Tendencias de Mercado',
      competitiveLandscape: 'Panorama Competitivo',
      growthOpportunities: 'Oportunidades de Crecimiento',
      revenueModel: 'Modelo de Ingresos',
      monetizationStrategy: 'Estrategia de Monetización',
      fundingRound: 'Ronda de Financiación',
      fundingAmount: 'Monto de Financiación',
      keyInvestors: 'Inversores Clave',
      keyMetrics: 'Métricas Clave',
      ceoFounder: 'CEO/Fundador',
      founderBackground: 'Antecedentes del Fundador',
      teamSize: 'Tamaño del Equipo',
      keyTeamMembers: 'Miembros Clave del Equipo',
      patentsIp: 'Patentes y PI',
      coreTechnologies: 'Tecnologías Centrales',
      aiMlCapabilities: 'Capacidades de IA/ML',
      infrastructure: 'Infraestructura',
      techDifferentiators: 'Diferenciadores Tecnológicos',
      website: 'Sitio Web',
      strategicPartnerships: 'Alianzas Estratégicas',
      analysisConfidence: 'Confianza del Análisis',
      primarySource: 'Fuente Principal',
      extractionMethod: 'Método de Extracción',
      generatedDate: 'Fecha de Generación',
      usedIn: 'Usado en:',
    },
    processing: {
      title: 'Procesando Startups',
      pleaseWait: 'Esto puede tomar varios minutos. Por favor no cierre esta página.',
      progress: 'Progreso',
      estimatedTime: '~10 minutos por cada 25 startups',
      errorTitle: 'Procesamiento Fallido',
      defaultError: 'Ocurrió un error durante el procesamiento.',
      tryAgain: 'Intentar de Nuevo',
      completedTitle: 'Procesamiento Completo',
      completedMessage: 'Todas las startups han sido procesadas exitosamente.',
      continue: 'Continuar',
      csvTitle: 'Procesando Archivo CSV',
      csvMessage: 'Extrayendo dimensiones de startup usando IA...',
      onepagerTitle: 'Generando OnePagers',
      onepagerMessage: 'Creando onepagers completos usando GPT-5-mini...',
      insertTitle: 'Insertando Startups',
      insertMessage: 'Guardando startups en base de datos y generando embeddings...',
    },
  },

  // Applications Admin
  applications: {
    pending: {
      title: 'Solicitudes Pendientes',
      subtitle: 'Revisar y procesar solicitudes de emprendedores pendientes de aprobación',
      refresh: 'Actualizar',
      cardTitle: 'Solicitudes Pendientes de Revisión',
      awaitingReview: '{{count}} solicitud(es) pendientes de revisión',
      noPending: 'No hay solicitudes pendientes',
      noEmail: 'Sin email',
      profile: 'Perfil',
      rejectionReason: 'Motivo de Rechazo',
      rejectionPlaceholder: 'Proporcionar retroalimentación al solicitante...',
      confirmRejection: 'Confirmar Rechazo',
      cancel: 'Cancelar',
      evaluating: 'IA Evaluando',
    },
    approved: {
      title: 'Solicitudes Aprobadas',
      subtitle: 'Emprendedores que han recibido acceso a la plataforma',
      noApproved: 'No hay solicitudes aprobadas',
      noApprovedDesc: 'Aún no se han aprobado solicitudes',
      approved: 'Aprobado',
      noHeadline: 'Sin titular',
      approvedTime: 'Aprobado {{time}}',
      viewDetails: 'Ver Detalles',
    },
    rejected: {
      title: 'Solicitudes Rechazadas',
      subtitle: 'Solicitudes que han sido revisadas y denegadas',
      noRejected: 'No hay solicitudes rechazadas',
      noRejectedDesc: 'No se han rechazado solicitudes',
      rejected: 'Rechazado',
      noHeadline: 'Sin titular',
      rejectedTime: 'Rechazado {{time}}',
      reason: 'Motivo:',
      viewDetails: 'Ver Detalles',
    },
  },

  // Founders Hub Sidebar
  foundershub: {
    sidebar: {
      title: "founder's hub",
      dashboard: 'panel',
      applications: 'solicitudes',
      entrepreneurs: 'emprendedores',
      projects: 'proyectos',
    },
    projects: {
      subtitle: 'Ver proyectos y sus emprendedores emparejados',
    },
    participant: {
      noAccess: 'Tu cuenta no tiene acceso a Founders Hub.',
    },
  },

  gaia: {
    programs: {
      projectOne: '1 proyecto asignado',
      projectCount: '{{total}} proyectos asignados',
      createdOn: 'Alta en Gaia: {{date}}',
      title: 'programas',
      subtitle: 'Cada programa define las fases, actividades y entregables que heredan los proyectos.',
      new: 'Nuevo programa',
      empty: 'Todavía no hay programas. Crea el primero para empezar a definir fases.',
      itemType: 'programa',
      publish: 'Publicar',
      publishConfirm: 'El programa pasará a estado Activo.',
      publishedToast: 'Programa publicado.',
      publishFailed: 'No se ha podido publicar el programa.',
      createFailed: 'No se ha podido crear el programa.',
      updateFailed: 'No se ha podido guardar el programa.',
      deleteFailed: 'No se ha podido eliminar el programa.',
    },
    programStatus: {
      draft: 'Borrador',
      active: 'Activo',
      archived: 'Archivado',
    },
    programBuilder: {
      noExpert: 'Sin experto',
      projects: 'Proyectos asignados',
      projectsEmpty: 'Todavía no hay ningún proyecto recorriendo este programa.',
      phases: 'Fases del programa',
      newPhase: 'Nueva fase',
      phasesEmpty: 'Este programa todavía no tiene fases. Crea la primera para definir su recorrido.',
      phaseItemType: 'fase',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      objective: 'Objetivo',
      activities: 'Actividades',
      newActivity: 'Nueva actividad',
      activitiesEmpty: 'Esta fase todavía no tiene actividades.',
      activityItemType: 'actividad',
      deliverableOne: '1 entregable',
      deliverableCount: '{{total}} entregables',
      gate: 'Gate',
      newGate: 'Nuevo gate',
      gateEmpty: 'Esta fase todavía no tiene gate. Añade uno para poder cerrarla.',
      gateItemType: 'gate',
      locked: 'Este programa ya tiene {{total}} proyectos en marcha, así que no puede modificarse en esta versión. Lo único que sí puedes cambiar es el experto responsable de cada actividad, y el cambio se aplica a todos los proyectos en marcha.',
      changeExpert: 'Cambiar experto',
    },
    programForm: {
      newTitle: 'Nuevo programa',
      editTitle: 'Editar programa',
      description: 'Un programa es la plantilla de fases, actividades y entregables que heredan los proyectos.',
      name: 'Nombre',
      namePlaceholder: 'Nombre del programa',
      descriptionLabel: 'Descripción',
      status: 'Estado',
      icon: 'Icono',
      removeIcon: 'Quitar icono',
    },
    gateForm: {
      newTitle: 'Nuevo gate',
      editTitle: 'Editar gate',
      description: 'El gate cierra la fase: el proyecto no avanza hasta que se aprueba.',
      name: 'Nombre',
      namePlaceholder: 'Nombre del gate',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Qué debe validarse para superar la fase',
    },
    projects: {
      title: 'proyectos',
      subtitle: 'Cada proyecto representa una startup o equipo participante en un programa.',
      new: 'Nuevo proyecto',
      search: 'Buscar proyecto...',
      empty: 'Todavía no hay proyectos. Crea el primero sobre un programa configurado.',
      noneAssigned: 'Todavía no estás asignado a ningún proyecto.',
      itemType: 'proyecto',
      program: 'Programa',
      phaseCount: '{{completed}}/{{total}} fases',
      createFailed: 'No se ha podido crear el proyecto.',
      updateFailed: 'No se ha podido guardar el proyecto.',
      deleteFailed: 'No se ha podido eliminar el proyecto.',
      editLocked_one: 'Este proyecto ya tiene un emprendedor recorriéndolo, así que sus datos no pueden modificarse. El coordinador del proyecto sí puede cambiarse en cualquier momento, y las acciones de estado (pausar, completar, cancelar) siguen disponibles.',
      editLocked_other: 'Este proyecto ya tiene {{count}} emprendedores recorriéndolo, así que sus datos no pueden modificarse. El coordinador del proyecto sí puede cambiarse en cualquier momento, y las acciones de estado (pausar, completar, cancelar) siguen disponibles.',
    },
    projectStatus: {
      draft: 'Borrador',
      active: 'Activo',
      paused: 'Pausado',
      completed: 'Completado',
      cancelled: 'Cancelado',
      activateAction: 'Activar',
      pauseAction: 'Pausar',
      resumeAction: 'Reanudar',
      completeAction: 'Completar',
      cancelAction: 'Cancelar',
    },
    lifecycle: {
      blocked: 'Bloqueada',
      in_progress: 'En curso',
      in_review: 'En revisión',
      approved: 'Aprobada',
      rejected: 'Rechazada',
      completed: 'Completada',
      enabled: 'Habilitado',
      pending: 'Pendiente',
    },
    projectForm: {
      startedAt: 'Fecha de arranque',
      startedAtHint: 'Las fechas límite de cada fase se calculan desde aquí, con las duraciones que define el programa.',
      newTitle: 'Nuevo proyecto',
      editTitle: 'Editar proyecto',
      description: 'Define los datos del proyecto y asigna a las personas implicadas.',
      name: 'Nombre',
      namePlaceholder: 'Nombre del proyecto',
      descriptionLabel: 'Descripción',
      status: 'Estado',
      program: 'Programa',
      programPlaceholder: 'Selecciona un programa',
      programLocked: 'El programa no se puede cambiar una vez que el proyecto lo ha materializado.',
    },
    activityForm: {
      expert: 'Experto responsable de la evaluación',
      expertPlaceholder: 'Elegir experto',
      removeExpert: 'Quitar experto',
      expertHint: 'Experto por defecto que validará esta actividad en los proyectos. Si lo cambias aquí, se aplica a todos los proyectos en marcha.',
      changeExpertTitle: 'Cambiar experto',
      newTitle: 'Nueva actividad',
      editTitle: 'Editar actividad',
      name: 'Nombre',
      namePlaceholder: 'Nombre de la actividad',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Qué debe hacer el equipo en esta actividad',
      deliverables: 'Entregables',
      addDeliverable: 'Añadir entregable',
      deliverablesHint: 'Cada entregable puede llevar asociado un documento de referencia para que el revisor compare lo esperado con el resultado entregado.',
      noDeliverables: 'Todavía no hay entregables definidos.',
      deliverableNamePlaceholder: 'Nombre del entregable',
      deliverableDescriptionPlaceholder: 'Descripción del entregable',
      removeDeliverable: 'Eliminar entregable',
      documentation: 'Documentación y plantillas',
      documentationHint: 'Añade enlaces (texto con hipervínculo) o sube archivos descargables directamente desde la actividad.',
      noLinks: 'Todavía no hay enlaces añadidos.',
      linkLabelPlaceholder: 'Texto del enlace',
      addLink: 'Añadir enlace',
        invalidLink: 'Introduce una dirección web válida (http o https).',
      removeLink: 'Eliminar enlace',
      uploadFile: 'Subir archivo descargable',
      removeDocument: 'Eliminar archivo',
      saveBeforeUpload: 'Los archivos se subirán cuando guardes la actividad.',
      pendingUpload: 'Se subirá al guardar',
      uploadFailed: 'No se han podido subir: {{files}}',
      assignees: 'Equipo asignado a la actividad',
      noAssignees: 'Todavía no hay nadie asignado a la actividad.',
    },
    assigneePicker: {
      // "experto de la actividad": desambigua del experto del comité de
      // terminus (UserRole.EXPERT) — comparten la palabra pero son cosas
      // distintas (§3.2).
      inviteMentor: 'Invitar a un experto de la actividad',
    },
    mentorInvite: {
      hint: 'Se le invitará a Gaia como miembro responsable de la actividad y recibirá un email. Si ya existe en la organización, solo se le añade el acceso.',
      email: 'Email',
      fullName: 'Nombre',
      submit: 'Invitar experto',
      error: 'No se ha podido invitar al experto.',
      title: 'Equipo',
      add: 'Añadir persona',
      empty: 'Todavía no hay nadie asignado.',
      reference: 'Marcar como persona de referencia',
      remove: 'Quitar',
      pickerHint: 'Personas de tu organización que pueden hacerse cargo del trabajo.',
      searchPlaceholder: 'Buscar por nombre o email...',
      noCandidates: 'No hay personas disponibles.',
    },
    phaseForm: {
      deadlineOffset: 'Plazo',
      deadlineOffsetPlaceholder: 'Elige un plazo',
      deadlineOffsetHint: 'La fecha límite de la fase se cuenta desde que se cierra el gate de la fase anterior (o desde el arranque del proyecto, si es la primera).',
      newTitle: 'Nueva fase',
      editTitle: 'Editar fase',
      name: 'Nombre',
      namePlaceholder: 'Nombre de la fase',
      descriptionLabel: 'Descripción',
      objective: 'Objetivo',
      team: 'Equipo asignado a la fase',
      teamEmpty: 'Todavía no hay nadie asignado a la fase.',
    },
    phases: {
      dueDate: 'Fecha límite {{date}}',
      setDueDate: 'Fijar fecha límite',
      overdue: 'Vencida',
      editDueDate: 'Editar fecha límite',
      manualBadge: 'Manual',
      manualHint: 'Fijada a mano — ya no se recalcula sola.',
      title: 'Fases del programa',
      subtitle: '{{completed}} de {{total}} fases completadas',
      activityCount: '{{approved}}/{{total}} actividades',
      objective: 'Objetivo de la fase',
      empty: 'Este proyecto todavía no tiene un programa asignado.',
      deadlineOffset: {
        '1w': '1 semana',
        '2w': '2 semanas',
        '3w': '3 semanas',
        '4w': '4 semanas',
      },
    },
    activities: {
      title: 'Actividades',
      count: '{{approved}} de {{total}} aprobadas',
      more: 'Ver más',
      less: 'Ver menos',
      deliverables: 'Entregables',
      documentation: 'Otra documentación',
      noDeliverables: 'Sin entregables definidos.',
      empty: 'Esta fase no tiene actividades.',
      feedbackPlaceholder: 'Feedback para el emprendedor...',
      submissionMessage: 'Comentario para el evaluador (opcional)',
      submitForReview: 'Enviar actividad a revisión',
      approve: 'Aprobar actividad',
      reject: 'Rechazar',
      submissionLabel: 'Comentario de entrega',
      feedbackLabel: 'Feedback del evaluador',
      expert: 'Experto responsable de la evaluación',
      noExpert: 'Sin asignar',
      enableFailed: 'No se ha podido desbloquear la actividad.',
      dueDateFailed: 'No se ha podido cambiar la fecha límite.',
    },
    gate: {
      generateDossier: 'Generar dossier',
      dossierNotImplemented: 'not yet implemented',
      downloadDossier: 'Descargar dossier',
      uploadReport: 'Subir informe post-gate',
      approve: 'Aprobar gate',
      reject: 'Rechazar',
      feedbackPlaceholder: 'Feedback del evaluador...',
      blockedHint: 'Este gate se habilitará cuando todas las actividades de la fase estén aprobadas.',
    },
    deliverables: {
      status: {
        pending: 'Pendiente',
        submitted: 'Enviado',
        approved: 'Aprobado',
        rejected: 'Rechazado',
      },
      upload: 'Subir fichero',
      submit: 'Enviar a revisión',
      approve: 'Aprobar',
      reject: 'Rechazar',
      feedbackRequired: 'Escribe feedback para poder rechazar.',
      needsFileTooltip: 'El entregable necesita al menos un fichero.',
      reorder: 'Reordenar',
      empty: 'Todavía no hay ficheros.',
    },
    reviewHistory: {
      title: 'Historial de revisiones',
      readOnly: 'Este historial es de solo lectura: no puede modificarse.',
      empty: 'Todavía no se ha solicitado ninguna revisión en esta fase.',
      activity: 'Actividad',
      gate: 'Gate',
      noRequest: 'Sin solicitud asociada',
      submitted: 'Enviado el {{date}} por {{name}}',
      resolved: 'Resuelto el {{date}} por {{name}}',
      comment: 'Comentario',
      feedback: 'Feedback',
      unknownPerson: 'Sin identificar',
    },
    activityLog: {
      empty: 'Todavía no hay actividad registrada.',
      actions: {
        meeting_convened: 'Reunión convocada',
        meeting_updated: 'Reunión modificada',
        meeting_cancelled: 'Reunión cancelada',
        meeting_summary_saved: 'Resumen de la reunión guardado',
        meeting_validated: 'Reunión validada',
        file_uploaded: 'Fichero subido',
        file_removed: 'Fichero eliminado',
        files_reordered: 'Ficheros reordenados',
        deliverable_submitted: 'Entregable enviado a revisión',
        deliverable_approved: 'Entregable aprobado',
        deliverable_rejected: 'Entregable rechazado',
        activity_submitted: 'Actividad enviada a revisión',
        activity_rejected: 'Actividad rechazada',
        activity_approved: 'Actividad aprobada',
        activity_opened: 'Actividad abierta',
        phase_started: 'Fase iniciada',
        phase_completed: 'Fase completada',
        gate_enabled: 'Gate habilitado',
        gate_approved: 'Gate aprobado',
        gate_rejected: 'Gate rechazado',
        post_gate_report_uploaded: 'Informe post-gate subido',
        project_created: 'Proyecto creado',
        project_activated: 'Proyecto activado',
        project_completed: 'Proyecto completado',
        assignment_added: 'Persona asignada',
        assignment_removed: 'Persona desasignada',
        due_date_overridden: 'Fecha límite modificada',
      },
    },
    coordinatorInvite: {
      invite: 'Invitar coordinador',
      hint: 'Se le invitará a Gaia como miembro y recibirá un email. Si ya existe en la organización, solo se le añade el acceso.',
      email: 'Email',
      fullName: 'Nombre',
      submit: 'Invitar coordinador',
      error: 'No se ha podido invitar al coordinador.',
    },
    coordinator: {
      title: 'Coordinador del proyecto',
      reference: 'Persona de referencia',
      assign: 'Asignar',
      override: 'Cambiar',
      inherited: 'Heredado del programa',
      assignTitle: 'Coordinador del proyecto',
      assignHint: 'Solo aparece el personal de la organización del proyecto.',
      assignError: 'No se ha podido asignar el coordinador.',
      empty: 'No hay personal disponible para coordinar.',
      emptyPanel: 'Sin coordinador asignado.',
    },
    evaluators: {
      title: 'Expertos',
      empty: 'Sin expertos asignados a las actividades.',
    },
    members: {
      participants: 'Emprendedores',
      team: 'Equipo',
      add: 'Añadir',
      addParticipants: 'Añadir participantes',
      addTeam: 'Añadir equipo',
      participantsHint: 'Solo aparecen los emprendedores con acceso activo a Gaia.',
      teamHint: 'Personas de tu organización.',
      searchPlaceholder: 'Buscar por nombre o email...',
      empty: 'No hay personas disponibles.',
      emptyParticipants: 'Sin participantes asignados.',
      emptyTeam: 'Sin equipo asignado.',
      inviteEntrepreneur: 'Invitar emprendedor',
      inviteHint: 'Busca primero por nombre o email. Si ya existe en FoundersHub, se reutiliza su perfil y se le da acceso a Gaia; si no, recibirá una invitación por email.',
      inviteEmail: 'Email',
      inviteFullName: 'Nombre',
      inviteSuccess: 'Emprendedor invitado correctamente.',
      inviteError: 'No se ha podido invitar al emprendedor.',
      addFailed: 'No se ha podido añadir a la persona al proyecto.',
      removeFailed: 'No se ha podido quitar a la persona del proyecto.',
      pending: 'Pendiente',
    },
    participant: {
      myProjects: 'mis proyectos',
      myProjectsSubtitle: 'Los proyectos en los que participas.',
      noProjects: 'Todavía no estás asignado a ningún proyecto.',
      noAccess: 'Tu cuenta no tiene acceso a Gaia.',
    },
    history: {
      project: 'Historial del proyecto',
      phase: 'Historial de la fase',
    },
    sidebar: {
      dashboard: 'dashboard',
      projects: 'proyectos',
      meetings: 'reuniones',
      contracts: 'contratos',
      budgets: 'presupuestos & kpis',
      programs: 'programas',
      auditLog: 'audit log',
      evaluations: 'evaluaciones',
    },
    dashboard: {
      title: 'panel de control gaia',
      placeholder: 'Dashboard próximamente',
    },
    common: {
      comingSoon: 'Próximamente',
    },
    meetingStatus: {
      convened: 'Convocada',
      pending_validation: 'Pendiente de validación',
      no_validator: 'Sin validador',
      validated: 'Validada',
      cancelled: 'Cancelada',
    },
    meetings: {
      pageTitle: 'Reuniones',
      subtitle: 'Reuniones de seguimiento de tus proyectos.',
      participantSubtitle: 'Las reuniones a las que has sido convocado.',
      projectBlock: 'Reuniones',
      detail: 'Reunión',
      itemType: 'reunión',
      statAll: 'Reuniones',
      convene: 'Convocar reunión',
      edit: 'Editar reunión',
      search: 'Buscar reunión o proyecto...',
      filterProject: 'Todos los proyectos',
      allProjects: 'Todos los proyectos',
      filterStatus: 'Todos los estados',
      allStatuses: 'Todos los estados',
      empty: 'Todavía no hay reuniones.',
      emptySearch: 'No hay reuniones que coincidan con la búsqueda.',
      participantEmpty: 'No tienes reuniones asignadas.',
      projectEmpty: 'Todavía no hay reuniones para este proyecto.',
      projectEmptyCanConvene: 'Todavía no hay reuniones. Convoca la primera.',
      pendingSummary: 'Pendiente de resumen',
      project: 'Proyecto',
      chooseProject: 'Selecciona un proyecto',
      title: 'Título',
      objectives: 'Objetivos',
      dateTime: 'Fecha y hora',
      pastWarning: 'La reunión se registrará como ya celebrada; no se enviará convocatoria.',
      location: 'Enlace o lugar',
      attendees: 'Asistentes',
      selectProjectFirst: 'Selecciona un proyecto para ver sus emprendedores.',
      noMembers: 'Este proyecto no tiene emprendedores asignados.',
      membersError: 'No se ha podido cargar el equipo del proyecto.',
      requiredFields: 'Completa proyecto, asistentes, título, objetivos y fecha y hora para convocar la reunión.',
      noAttendeesWarning: 'Sin asistentes, la reunión quedará «Sin validador» y nadie podrá validarla.',
      noValidatorHint: 'Esta reunión no tiene ningún emprendedor con cuenta activa que pueda validarla. Edita la convocatoria para añadir uno.',
      summary: 'Resumen',
      summaryPlaceholder: 'Escribe lo tratado en la reunión...',
      summaryMetadata: 'Escrito por',
      unknownAuthor: 'usuario no disponible',
      saveError: 'No se ha podido guardar la reunión.',
      summaryError: 'No se ha podido guardar el resumen.',
      cancelError: 'No se ha podido cancelar la reunión.',
      cancelAction: 'Cancelar',
      validateError: 'No se ha podido validar la reunión.',
      noSummary: 'Aún no hay resumen.',
      saveAndNotify: 'Guardar y notificar a los participantes',
      saveSummary: 'Guardar resumen',
      requestValidation: 'Solicitar validación',
      validate: 'Validar reunión',
      validateConfirmTitle: 'Validar reunión',
      validateNeedsSummary: 'El organizador debe añadir un resumen antes de que puedas validar la reunión.',
      validateConfirmDescription: 'Confirmas que la reunión se celebró y que el resumen refleja lo tratado. Queda registrado como evidencia y no se puede deshacer.',
      validatedAt: 'Reunión validada por',
      cancelConfirmTitle: 'Cancelar reunión',
      cancelConfirmDescription: 'La reunión quedará registrada como cancelada y se avisará a los emprendedores convocados.',
      loadError: 'No se ha podido cargar la reunión.',
      notAvailable: 'Reunión no disponible.',
      summarySaved: 'Resumen guardado.',
      summarySavedValidationRequested: 'Resumen guardado. Se ha pedido a los asistentes que validen la reunión.',
      noCalendarSyncHint: 'Gaia no recibe las respuestas del calendario: si la convocatoria cambia o se acepta allí, hay que reflejarlo aquí. La validación del emprendedor confirma que la reunión se celebró, y queda como evidencia.',
      validatorsTitle: 'Pueden validarla',
      validatorsNone: 'Ningún emprendedor con cuenta activa puede validarla todavía.',
      pendingValidationCount_one: '{{count}} resumen pendiente de validar',
      pendingValidationCount_other: '{{count}} resúmenes pendientes de validar',
    },
  },

  people: {
    profile: {
      title: 'personas',
      manageAccount: 'Gestionar cuenta',
    },
    sections: {
      details: 'datos',
      cv: 'CV',
      gaiaProjects: 'proyectos',
      gaiaDeliverables: 'entregables',
      gaiaMeetings: 'reuniones',
      foundershubApplication: 'solicitud',
      foundershubOpportunities: 'oportunidades',
      foundershubApplications: 'candidaturas',
    },
    details: {
      editTitle: 'Editar datos',
    },
    gaia: {
      projectsEmpty: 'No hay proyectos de esta persona que puedas ver.',
      deliverablesEmpty: 'No hay entregables asignados a esta persona que puedas ver.',
      meetingsEmpty: 'No hay reuniones de esta persona que puedas ver.',
      seats: {
        coordinator: 'coordinador',
        evaluator: 'experto',
        team: 'equipo',
      },
    },
    foundershub: {
      openApplication: 'Abrir revisión de la solicitud',
      opportunitiesEmpty: 'No hay oportunidades abiertas de esta persona que puedas ver.',
      applicationsEmpty: 'No hay candidaturas de esta persona que puedas ver.',
    },
  },

  users: {
    title: 'usuarios y permisos',
    errors: {
      hasGaiaEvidence: 'No se puede eliminar este usuario: ha entregado entregables o aceptado documentos en un proyecto de gaia, y ese registro debe conservarse. Desactiva la cuenta en su lugar.',
      alreadyMemberWithRole: 'Esta persona ya es de tu organización con otro rol. Invitar no cambia el rol: usa «cambiar rol» en Equipo.',
    },
    myProfileTitle: 'mi perfil',
    subtitle: 'Gestiona roles y permisos de acceso del personal',
    stats: {
      total: 'total personal',
      admins: 'administradores',
      staff: 'personal de programa',
    },
    you: 'tú',
    viewProfile: 'Ver Perfil',
    editPermissions: 'Editar Rol y Permisos',
    editPermissionsTitle: 'Editar Rol y Permisos',
    editPermissionsDesc: 'Actualizar rol y acceso para {{name}}',
    sendReset: 'Enviar Restablecimiento',
    sendResetSuccess: 'Email de restablecimiento enviado a {{email}}',
    sendResetError: 'Error al enviar email de restablecimiento',
    resendInvite: 'Reenviar Invitación',
    resendInviteSuccess: 'Invitación reenviada a {{email}}',
    resendInviteError: 'Error al reenviar la invitación',
    role: 'rol',
    permissions: 'permisos',
    adminSuperuser: 'Los administradores tienen acceso completo a la plataforma y omiten todas las verificaciones.',
    save: 'Guardar',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    noUsers: 'No se encontraron usuarios del personal',
    detail: {
      basicInfo: 'información básica',
      security: 'seguridad',
      username: 'nombre de usuario',
      email: 'correo electrónico',
      edit: 'Editar',
      saveInfo: 'Guardar',
      saveInfoSuccess: 'Información de usuario actualizada',
      saveInfoError: 'Error al actualizar información de usuario',
      savePermsSuccess: 'Permisos actualizados',
      savePermsError: 'Error al actualizar permisos',
      sendResetBtn: 'Enviar Enlace de Restablecimiento',
      sendResetDesc: 'Enviar email de restablecimiento a {{email}}',
      notFound: 'Usuario no encontrado',
      platformAccess: 'acceso a plataformas',
      noPlatformAccess: 'sin productos concedidos todavía',
    },
  },

  superadmin: {
    sidebar: {
      organizations: 'organizaciones',
      users: 'usuarios y permisos',
    },
    orgs: {
      title: 'organizaciones',
      subtitle: 'Gestiona las organizaciones cliente y su acceso a herramientas',
      create: 'Nueva organización',
      creating: 'Creando...',
      createTitle: 'Crear organización',
      createDesc: 'Configura una nueva organización cliente con acceso a herramientas.',
      createSuccess: 'Organización "{{name}}" creada',
      createError: 'Error al crear organización',
      empty: 'Sin organizaciones aún',
      notFound: 'Organización no encontrada',
      tools: 'herramientas y acceso',
      members: 'miembros',
      enabled: 'activo',
      disabled: 'inactivo',
      featuresSaved: 'Acceso a herramientas actualizado',
      featuresSaveError: 'Error al actualizar acceso a herramientas',
      enabledRoles: 'roles asignables',
      rolesSaved: 'Roles asignables actualizados',
      rolesSaveError: 'Error al actualizar roles asignables',
      noRolesEnabled: 'Ningún rol habilitado',
      invitePlatform: 'plataforma',
      noPlatformsEnabled: 'Ninguna plataforma habilitada',
      invite: 'Invitar usuario',
      inviting: 'Invitando...',
      inviteTitle: 'Invitar usuario',
      inviteDesc: 'Crea un nuevo usuario y añádelo a {{org}}. Se enviará un email de configuración.',
      inviteSent: 'Invitación enviada a {{email}}',
      inviteError: 'Error al invitar usuario',
      noMembers: 'Sin miembros aún',
      fields: {
        name: 'nombre',
        slug: 'slug',
        features: 'herramientas',
      },
    },
    users: {
      subtitle: 'Roles y control de acceso del personal en toda la plataforma',
    },
    allUsers: {
      title: 'todos los usuarios',
      stats: {
        total: 'total',
        entrepreneurs: 'emprendedores',
        staff: 'personal',
        active: 'activos',
        pending: 'pendientes',
        disabled: 'deshabilitados',
      },
      filters: {
        search: 'Buscar por nombre o email...',
        role: 'Todos los roles',
        state: 'Todos los estados',
        clear: 'Limpiar filtros',
      },
      roleLabels: {
        entrepreneur: 'Emprendedor',
        superadmin: 'Superadmin',
        orgAdmin: 'Admin de Org',
        staff: 'Todo el Personal',
      },
      stateLabels: {
        active: 'Activo',
        pending: 'Pendiente',
        disabled: 'Deshabilitado',
      },
      perPage: 'por página',
      table: {
        empty: 'No se encontraron usuarios',
      },
      pagination: {
        showing: 'Mostrando {{from}}–{{to}} de {{total}}',
      },
      deleteSuccess: 'Usuario "{{name}}" eliminado',
      deleteError: 'Error al eliminar el usuario',
    },
  },

  // Organization
  expert: {
    sidebar: {
      committees: 'comités',
    },
  },

  org: {
    sidebar: {
      dashboard: 'panel',
      team: 'equipo',
      platformTerminus: 'terminus',
      platformFoundershub: "founder's hub",
      platformGaia: 'gaia',
    },
    platform: {
      nav: 'organización',
      title: 'organización de {{product}}',
      subtitle: 'Derechos de producto y ajustes específicos de {{product}}',
      products: {
        terminus: 'terminus',
        foundershub: "founder's hub",
        gaia: 'gaia',
      },
      settings: {
        entitlement: 'producto',
        entitlementDesc: 'Si esta organización tiene derecho a {{product}}',
        enabled: 'activado',
        notEnabled: 'no activado',
        organization: 'id de organización',
        organizationDesc: 'Cada miembro pertenece exactamente a una organización',
        managedNote: 'Los derechos de producto los gestiona un superadmin. La pertenencia y los roles se gestionan aquí, por producto.',
        disable: 'desactivar',
        disableSuccess: 'acceso desactivado',
        disableError: 'no se pudo desactivar el acceso',
        reactivate: 'reactivar',
        reactivateSuccess: 'acceso reactivado',
        reactivateError: 'no se pudo reactivar el acceso',
        grant: 'conceder acceso',
        grantSuccess: 'acceso concedido',
        grantError: 'no se pudo conceder el acceso',
      },
    },
    dashboard: {
      title: 'organización',
      subtitle: 'Gestiona tu equipo, permisos y cuentas de expertos',
      stats: {
        totalAdmins: 'admins',
        totalExperts: 'expertos',
        activeExperts: 'activos',
        pendingExperts: 'pendientes',
      },
      currentUser: 'tu cuenta',
      role: 'Rol',
      scopes: 'Permisos',
      quickLinks: 'enlaces rápidos',
      manageTeam: 'gestionar equipo',
      manageTeamDesc: 'Ver usuarios admin, editar roles y permisos',
    },
    team: {
      title: 'equipo',
      subtitle: 'Gestiona tu equipo y consulta su acceso de un vistazo',
      stats: {
        total: 'total',
        experts: 'expertos',
        admins: 'administradores',
        members: 'miembros',
        entrepreneurs: 'emprendedores',
        pending: 'pendientes',
      },
      roles: {
        admin: 'administrador',
        member: 'miembro',
        entrepreneur: 'emprendedor',
      },
      filters: { all: 'todos' },
      allPlatforms: 'todas las plataformas',
      items: 'personas',
      searchPlaceholder: 'Buscar por nombre, email o rol...',
      empty: 'No se encontraron miembros con estos filtros',
      you: 'tú',
      pending: 'pendiente',
      // Identidad + elegibilidad, nunca un permiso (§8.3) — "experto del
      // comité", no "experto" a secas: desambigua del experto de actividad
      // de Gaia (evaluador) en pantalla, ya que comparten la palabra pero son
      // cosas distintas.
      expertBadge: 'experto del comité',
      editSectors: 'editar sectores',
      editSectorsTitle: 'editar sectores',
      editSectorsDesc: 'Sectores en los que este experto del comité tiene conocimiento — es la elegibilidad de {{name}}, no un permiso.',
      sectorsSaved: 'Sectores actualizados',
      sectorsError: 'Error al actualizar los sectores',
      // Un contador de solo lectura con enlace al objeto que lo contiene — la
      // asignación ES el permiso, y se crea o se quita donde vive el objeto
      // (el comité, el proyecto), nunca aquí (§8.3).
      grantsCount: '{{count}} asignación',
      grantsCount_plural: '{{count}} asignaciones',
      editRole: 'cambiar rol',
      alreadyMemberWithRole: '{{name}} ya es {{role}} de tu organización. Invitar no cambia el rol: usa «cambiar rol».',
      editRoleTitle: 'cambiar rol',
      editRoleDesc: 'Actualiza el rol de {{name}} en esta organización',
      roleSaved: 'Rol actualizado',
      roleError: 'Error al actualizar el rol',
      save: 'Guardar',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      noAdmins: 'No se encontraron usuarios admin',
      errorLoading: 'Error al cargar usuarios admin: {{message}}',
      invite: 'invitar usuario',
      inviteTitle: 'Invitar a un miembro del equipo',
      inviteDesc: 'Invita a un administrador, miembro o emprendedor. Cada persona recibe el acceso y flujo apropiados para su tipo.',
      inviteEmail: 'Email',
      inviteFullName: 'Nombre completo',
      inviteFullNamePlaceholder: 'Juan Pérez',
      invitePlatform: 'Producto',
      inviteRole: 'Rol',
      inviteSubmit: 'Enviar invitación',
      inviteSending: 'Enviando...',
      inviteSuccess: 'Invitación enviada a {{email}}',
      inviteError: 'Error al invitar al usuario',
      remove: 'eliminar de la organización',
      removeTitle: 'Eliminar miembro del equipo',
      removeDesc: '¿Eliminar a {{name}} ({{email}}) de tu organización? Esta acción borra la cuenta de usuario de forma permanente y revoca su acceso.',
      removeConfirm: 'Eliminar usuario',
      removing: 'Eliminando...',
      removeSuccess: '{{name}} eliminado de la organización',
      removeError: 'Error al eliminar al usuario',
      resendInvite: 'reenviar invitación',
      resendInviteSuccess: 'Invitación reenviada a {{email}}',
      resendInviteError: 'Error al reenviar la invitación',
      revokeAccess: 'quitar de la plataforma',
      revokeAccessTitle: 'Revocar acceso a la plataforma',
      revokeAccessDesc:
        '¿Revocar el acceso de {{name}} a {{platforms}}? No se elimina la cuenta: conserva su perfil y cualquier acceso concedido por otra organización, y podrás volver a concedérselo más adelante.',
      revokeAccessConfirm: 'Revocar acceso',
      revokeAccessSuccess: '{{name}} ya no tiene acceso a {{platforms}}',
      revokeAccessError: 'Error al revocar el acceso',
    },
  },

  // All Applications View
  allApplications: {
      projectsLabel: 'Proyectos',
      avatarAlt: 'Avatar',
    title: 'Emprendedores',
    subtitle: 'Revisa y gestiona emprendedores a lo largo de su proceso',
    errorLoading: 'Error al cargar solicitudes: {{message}}',
    status: {
      approved: 'Aprobado',
      approvedDesc: 'Solicitud aprobada, usuario con acceso a la plataforma',
      rejected: 'Rechazado',
      rejectedDesc: 'Solicitud no aprobada',
      readyForReview: 'Listo para revisión',
      readyForReviewDesc: 'Pre-score aprobado, pendiente de revisión',
      postScoring: 'Post-Evaluación',
      postScoringDesc: 'Notas del admin añadidas, evaluación post completada',
      failedPreScore: 'Pre-Score fallido',
      failedPreScoreDesc: 'Primer intento fallido, puede reintentar',
      processing: 'Procesando',
      processingDesc: 'Evaluación IA en progreso',
      onboarding: 'Registro',
      onboardingDesc: 'Completando formulario de perfil',
      linkedInPending: 'LinkedIn pendiente',
      linkedInPendingDesc: 'Esperando importación de perfil de LinkedIn',
      defaultDesc: 'Estado pendiente',
    },
    stats: {
        approvalRate: 'Tasa de aprobación',
      total: 'Total',
      totalTooltip: 'Total de solicitudes en el sistema',
      pendingReview: 'Revisión pendiente',
      pendingReviewTooltip: 'Solicitudes listas para revisión',
      processing: 'En proceso',
      processingTooltip: 'Solicitudes en progreso (registro, evaluación IA)',
      approved: 'Aprobadas',
      approvedTooltip: 'Emprendedores aprobados exitosamente',
      rejected: 'Rechazadas',
      rejectedTooltip: 'Solicitudes no aprobadas',
    },
    filters: {
      all: 'Todas las solicitudes',
      pendingReview: 'Revisión pendiente',
      processing: 'En proceso',
      approved: 'Aprobadas',
      rejected: 'Rechazadas',
      statusFilter: 'Filtro de estado',
      clearFilters: 'Limpiar filtros',
      searchPlaceholder: 'Buscar por nombre o email...',
      applicationsCount: '{{count}} solicitudes',
    },
    emptyState: {
      noApplications: 'No se encontraron solicitudes',
    },
    scores: {
      pre: 'Pre',
      post: 'Post',
      preScore: 'Pre-Score',
      postScore: 'Post-Score',
      excellent: 'Candidato excelente',
      good: 'Buen potencial',
      needsReview: 'Necesita revisión',
    },
    journey: {
      title: 'Proceso',
      journeyTitle: 'Proceso de solicitud',
      linkedin: 'LinkedIn',
      profile: 'Perfil',
      preScore: 'Pre-Score',
      review: 'Revisión',
      decision: 'Decisión',
    },
    legend: {
      scoreIndicator: 'Indicador de puntuación',
      journeyProgress: 'Progreso del proceso',
    },
    actions: {
      viewApplication: 'Ver solicitud',
      viewFullProfile: 'Ver perfil completo',
    },
  },

  // Founders Hub Dashboard
  foundersHubDashboard: {
    title: 'Panel del Hub de Fundadores',
    subtitle: 'Información en tiempo real sobre solicitudes y métricas de emprendedores',
    backToTerminus: 'Volver a Terminus',
    loadingMetrics: 'Cargando métricas...',
    failedToLoad: 'Error al cargar las métricas del panel',
    noDate: 'Sin fecha',
    metrics: {
      totalApplications: 'Total de Solicitudes',
      pendingReview: 'Revisión Pendiente',
      approvalRate: 'Tasa de Aprobación',
      avgProcessingTime: 'Tiempo Promedio de Procesamiento',
      thisWeek: 'esta semana',
    },
    charts: {
      applicationTimeline: 'Línea de Tiempo de Solicitudes (Últimos 7 Días)',
      dailyBreakdown: 'Desglose diario de estados de solicitudes',
      statusDistribution: 'Distribución de Estados',
      currentBreakdown: 'Desglose actual de solicitudes',
      preScoreDistribution: 'Distribución de Pre-Evaluación (Aprobados)',
      scoreRanges: 'Rangos de puntuación para emprendedores aprobados',
      recentActivity: 'Actividad Reciente',
      latestUpdates: 'Últimas actualizaciones de solicitudes',
    },
    pendingApplications: 'Solicitudes Pendientes',
    applicationsAwaitingReview: 'Solicitudes pendientes de revisión',
  },

  // Profile Review
  profileReview: {
    loading: 'Cargando tu perfil...',
    title: 'Revisa Tu Perfil',
    subtitle: 'Hemos importado tu información de LinkedIn. Por favor revisa y envía para aprobación.',
    linkedInVerified: 'Verificado por LinkedIn',
    profileInformation: 'Información del Perfil',
    importedFromLinkedIn: 'Información importada de tu perfil de LinkedIn',
    firstName: 'Nombre',
    lastName: 'Apellido',
    emailAddress: 'Dirección de Email',
    professionalHeadline: 'Titular Profesional',
    accountCreated: 'Cuenta Creada',
    notAvailable: 'No disponible',
    readyToSubmit: '¿Listo para Enviar?',
    reviewDescription: 'Tu perfil será revisado por nuestro equipo. Esto normalmente toma 24-48 horas. Recibirás un email una vez aprobado.',
    refreshProfile: 'Actualizar Perfil',
    submitting: 'Enviando...',
    submitForReview: 'Enviar para Revisión',
    privacyNotice: 'Al enviar tu perfil, consientes el procesamiento de tus datos de acuerdo con nuestra Política de Privacidad. Puedes actualizar o eliminar tu información en cualquier momento después de la aprobación.',
  },

  // User Menu
  userMenu: {
    profile: 'Perfil',
    settings: 'Configuración',
    signingOut: 'Cerrando sesión...',
    signOut: 'Cerrar Sesión',
    notSignedIn: 'No ha iniciado sesión',
    signIn: 'Iniciar Sesión',
    guest: 'Invitado',
  },

  // Login
  login: {
    signUpLink: 'Regístrate',
    founderPortal: 'Portal de Fundadores',
    poweredByVess: 'powered by vess.',
    contactSupport: 'Contactar soporte en',
    entrepreneurLink: '¿Eres emprendedor? Entra aquí',
    entrepreneurHint: '¿Eres emprendedor?',
    entrepreneurHintLink: 'Accede desde el acceso de emprendedores.',
    errors: {
      invalidCredentials: 'Email o contraseña incorrectos.',
      accountNotActivated: 'Tu cuenta aún no está activada. Usa el enlace de invitación que te enviamos por email para crear tu contraseña, o solicita restablecerla.',
      accountDisabled: 'Esta cuenta está desactivada. Contacta con tu organización si crees que es un error.',
      emailNotVerified: 'Tu email aún no está verificado. Busca en tu bandeja de entrada el enlace de verificación que te enviamos, o solicita uno nuevo desde la página de acceso.',
      ssoOnly: 'Esta cuenta se creó con SSO. Inicia sesión con tu proveedor.',
      passwordLoginDisabled: 'El acceso con contraseña no está disponible para este tipo de cuenta. Usa el método de acceso que indicaba tu invitación.',
      noAccount: 'No tienes cuenta con ese LinkedIn. Regístrate primero.',
      alreadyRegistered: 'Ya tienes cuenta con ese LinkedIn. Inicia sesión.',
      signupClosed: 'El registro con LinkedIn no está abierto en esta plataforma.',
      oauthFailed: 'No hemos podido completar el acceso con LinkedIn. Inténtalo de nuevo.',
    },
    forEntrepreneurs: 'Para emprendedores y fundadores de startups',
    invalidConfiguration: 'Configuración inválida',
    continueWith: 'Continuar con {{provider}}',
    or: 'o',
    email: 'Email',
    password: 'Contraseña',
    logIn: 'Iniciar Sesión',
    lastUsed: 'último utilizado',
    forgotPassword: '¿Olvidaste tu contraseña?',
    forgotPasswordDialog: {
      title: 'Restablecer contraseña',
      desc: 'Dinos la dirección con la que inicias sesión y te enviaremos un enlace para crear una contraseña nueva.',
      submit: 'Enviar enlace',
      confirmTitle: 'Revisa tu correo',
      confirmDesc: 'Si la dirección está registrada, te hemos enviado un enlace para restablecer la contraseña. Si no llega en unos minutos, revisa la carpeta de spam.',
    },
  },

  // Common
  // Project Detail (match card labels)
  projectDetail: {
    scoreDistribution: {
      topFit: 'Mejor Ajuste',
      strong: 'Fuerte',
      potential: 'Potencial',
      low: 'Bajo',
    },
    matchCard: {
      unknownEntrepreneur: 'Emprendedor Desconocido',
      yearsExperience: '{{years}}+ años',
      applied: 'Aplicó',
      matched: 'Emparejado',
      sector: 'Sector',
      role: 'Rol',
      keywords: 'Palabras Clave',
    },
  },
  markdownViewer: {
    downloadMarkdown: 'Markdown (.md)',
    downloadPdf: 'PDF (.pdf)',
  },

  // Application Profile Page
  applicationProfile: {
    backButton: 'Solicitudes',
    noHeadline: 'Sin titular',
    preScore: 'Pre-Evaluación',
    postScore: 'Post-Evaluación',
    aiEvaluationSummary: 'Resumen de Evaluación IA',
    strengths: 'Fortalezas',
    concerns: 'Preocupaciones',
    adminReview: 'Revisión del Administrador',
    discPersonality: 'Personalidad DISC',
    selectType: 'Seleccionar tipo...',
    none: 'Ninguno',
    notAssigned: 'No asignado',
    notes: 'Notas',
    addEvaluationNotes: 'Agregar notas de evaluación...',
    noNotesYet: 'Sin notas aún',
    networkCounts: 'Red de LinkedIn',
    connections: 'Conexiones',
    followers: 'Seguidores',
    connectionsPlaceholder: 'ej. 500',
    followersPlaceholder: 'ej. 1200',
    notSet: 'sin definir',
    networkCountsRequired: 'Las conexiones y seguidores son obligatorios y deben ser mayores que 0.',
    profileSummary: 'Resumen del Perfil',
    fullProfile: 'Perfil Completo',
    experience: 'Experiencia',
    education: 'Educación',
    status: {
      approved: 'Aprobado',
      rejected: 'Rechazado',
      readyForReview: 'Listo para Revisión',
      postScoring: 'Post-Evaluación',
      aiProcessing: 'Procesando IA',
    },
    score: {
      pending: 'Pendiente',
      excellent: 'Excelente',
      good: 'Bueno',
      needsReview: 'Necesita Revisión',
    },
    notesSections: {
      validacion: 'Evaluación General',
      perfil: 'Perfil Emprendedor',
      trayectoria: 'Trayectoria Profesional',
      red: 'Red y Validación Social',
    },
  },

  // Candidate Action Buttons
  candidateActions: {
    adminNotes: 'Notas del Administrador',
    approve: 'Aprobar',
    approveTooltip: 'Aprobar Solicitud',
    alreadyApproved: 'La solicitud ya está aprobada',
    reject: 'Rechazar',
    rejectTooltip: 'Rechazar Solicitud',
    alreadyRejected: 'La solicitud ya está rechazada',
    retriggerPreScore: 'Reiniciar Pre-Evaluación',
    retriggerPostScore: 'Reiniciar Post-Evaluación',
    retriggerLinkedin: 'Re-scraping LinkedIn',
    resetToInitial: 'Restablecer al Estado Inicial',
    notesDialog: {
      title: 'Notas del Administrador',
      description: 'Agregar notas de evaluación para esta solicitud. Estas notas son necesarias antes de la post-evaluación.',
      notesLabel: 'Notas',
      notesPlaceholder: 'Agregar tus notas sobre esta solicitud...',
      categories: {
        validacion: 'Evaluación General',
        validacionPlaceholder: 'Observaciones de entrevista, soft skills, motivación, red flags...',
        perfil: 'Perfil Emprendedor',
        perfilPlaceholder: 'Credenciales emprendedoras, fundraising, exits observados...',
        trayectoria: 'Trayectoria Profesional',
        trayectoriaPlaceholder: 'Trayectoria, logros, progresión verificada...',
        red: 'Red y Validación Social',
        redPlaceholder: 'Calidad de red, visibilidad, referencias...',
      },
      discLabel: 'Tipo de Personalidad DISC',
      discPlaceholder: 'Seleccionar un tipo de personalidad DISC...',
      none: 'Ninguno',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveNotes: 'Guardar Notas',
    },
    rejectDialog: {
      title: 'Rechazar Solicitud',
      description: 'Por favor proporcione un motivo para rechazar esta solicitud. Esta retroalimentación se almacenará con la solicitud.',
      reasonLabel: 'Motivo de Rechazo',
      reasonPlaceholder: 'Proporcionar retroalimentación al solicitante...',
      cancel: 'Cancelar',
      rejectApplication: 'Rechazar Solicitud',
    },
    resetDialog: {
      title: 'Restablecer Solicitud al Estado Inicial',
      description: 'Esto restablecerá la solicitud al estado PENDING_LINKEDIN_PARSE y eliminará todos los datos incluyendo:',
      linkedInData: 'Datos del perfil de LinkedIn',
      scores: 'Evaluaciones de pre-score y post-score',
      adminNotes: 'Notas del administrador',
      history: 'Todo el historial de aprobación/rechazo',
      cannotUndo: 'Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      resetting: 'Restableciendo...',
      resetApplication: 'Restablecer Solicitud',
    },
  },

  // Application Sidebar (AI Evaluation)
  applicationSidebar: {
    preScoreTitle: 'Evaluación IA Pre-Score',
    postScoreTitle: 'Evaluación IA Post-Score',
    preScoreNotCompleted: 'Evaluación pre-score aún no completada.',
    preScoreHint: 'Ejecutar la evaluación pre-score para ver insights de IA.',
    postScoreNotCompleted: 'Evaluación post-score aún no completada.',
    postScoreHint: 'Agregar notas del admin y evaluación DISC para activar la post-evaluación.',
    overallScore: 'Puntuación General',
    executiveSummary: 'Resumen Ejecutivo',
    subScoresBreakdown: 'Desglose de Sub-puntuaciones',
    formula: 'Fórmula: ',
    extractedFeatures: 'Características Extraídas',
    yearsExperience: 'Años de Experiencia:',
    avgTenure: 'Permanencia Promedio:',
    founderMonths: 'Meses como Fundador:',
    promotions: 'Promociones:',
    keywordsDensity: 'Densidad de Palabras Clave:',
    activityItems: 'Elementos de Actividad:',
    keyStrengths: 'Fortalezas Clave',
    areasOfConcern: 'Áreas de Preocupación',
    finalScore: 'Puntuación Final',
    finalRecommendation: 'Recomendación Final',
    executiveSummaryUpdated: 'Resumen Ejecutivo (Actualizado)',
    keyStrengthsFinal: 'Fortalezas Clave (Evaluación Final)',
    areasOfConcernFinal: 'Áreas de Preocupación (Evaluación Final)',
    finalReasoning: 'Razonamiento Final',
    nextSteps: 'Próximos Pasos',
    adminNotesAddressed: 'Notas del Admin Abordadas',
    personalityTraits: 'Rasgos de Personalidad:',
    appearanceAssessment: 'Evaluación de Apariencia:',
    preScoreConsideration: 'Consideración Pre-Score:',
  },

  tour: {
    tooltipReplay: 'Repetir tour guiado',
  },

  auth: {
    noAccessYet: 'Tu cuenta todavía no tiene acceso a ninguna sección. Pide a un administrador que te asigne un proyecto.',
    resetPassword: {
      title: 'establecer nueva contraseña',
      subtitle: 'Estableciendo contraseña para {{email}}',
      newPassword: 'nueva contraseña',
      confirmPassword: 'confirmar contraseña',
      submit: 'Establecer Contraseña',
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      submitError: 'Error al establecer contraseña. Inténtalo de nuevo.',
      invalidToken: 'enlace inválido o expirado',
      invalidTokenDesc: 'Este enlace de restablecimiento es inválido o ya fue utilizado.',
      backToLogin: 'volver al inicio de sesión',
      successTitle: 'contraseña actualizada',
      successDesc: 'Tu contraseña ha sido establecida. Ya puedes iniciar sesión.',
      usedToken: 'este enlace ya se usó',
      expiredInvitation: 'tu invitación ha caducado',
      expiredInvitationDesc: 'Pide otra y te la enviaremos al mismo email.',
      requestNewInvitation: 'pedir otra invitación',
      reissueNotSent: 'No hemos podido enviarte una invitación nueva. Pide a tu organización que te invite otra vez.',
      reissueError: 'No hemos podido pedir la invitación nueva. Inténtalo de nuevo.',
      reissuedTitle: 'invitación enviada',
      reissuedDesc: 'Te hemos enviado una invitación nueva. Revisa tu correo y usa el enlace nuevo.',
    },
    invitation: {
      title: 'crea tu contraseña',
      staffSubtitle: 'Te han invitado con {{email}}. Crea tu contraseña para entrar.',
      submit: 'crear contraseña',
      invalidDesc: 'Este enlace de invitación no es válido o ya no está activo. Si ya creaste tu contraseña, inicia sesión.',
      usedDesc: 'Tu cuenta ya está activa. Inicia sesión.',
      createdTitle: 'contraseña creada',
      createdDesc: 'Ya puedes iniciar sesión con tu email y tu contraseña.',
    },
    wrapper: {
      loading: 'Cargando...',
      redirecting: 'Redirigiendo al inicio de sesión...',
      accessForbidden: 'Acceso Denegado',
      noPermission: 'No tienes permiso para acceder a esta página.',
      returnToDashboard: 'Volver al Panel',
      featureNotAvailable: 'Función No Disponible',
      noOrgAccess: 'Tu organización no tiene acceso a esta herramienta.',
      authError: 'Error de Autenticación',
    },
  },
  monitoredSources: {
    title: 'fuentes monitorizadas',
    runSyncNow: 'sincronizar ahora',
    description: 'Feeds RSS/Atom leídos una vez al día para descubrir startups emergentes y noticias sobre tus startups en dealflow.',
    noSources: 'Aún no hay fuentes',
    active: 'activo',
    paused: 'pausado',
    pause: 'Pausar',
    activate: 'Activar',
    remove: 'Eliminar',
    namePlaceholder: 'Nombre (ej. TechCrunch)',
    urlPlaceholder: 'https://ejemplo.com/feed.xml',
    add: 'añadir',
    toasts: {
      sourceAdded: 'Fuente añadida',
      addFailed: 'Error al añadir la fuente',
      updateFailed: 'Error al actualizar la fuente',
      sourceRemoved: 'Fuente eliminada',
      removeFailed: 'Error al eliminar la fuente',
      syncJobTitle: 'Sincronización de fuentes',
      syncStarted: 'Sincronización iniciada',
      syncFailed: 'Error al iniciar la sincronización',
    },
  },

  orgSourcesPage: {
    title: 'fuentes.',
    subtitle: 'Feeds RSS/Atom que tu organización monitoriza para alimentar el dealflow.',
  },

  entrepreneurProfilePage: {
    noHeadline: 'Sin titular proporcionado',
    linkedin: 'LinkedIn',
    preScore: 'Pre-Score',
    postScore: 'Post-Score',
    tabs: {
      linkedin: 'Perfil de LinkedIn',
      preScore: 'Análisis Pre-Score',
      postScore: 'Análisis Post-Score',
    },
    linkedinNotAvailable: 'No hay datos de perfil de LinkedIn disponibles.',
    preScoreCard: {
      title: 'Evaluación IA Pre-Score',
      description: 'Evaluación inicial basada en los datos del perfil de LinkedIn',
    },
    postScoreCard: {
      title: 'Evaluación IA Post-Score',
      description: 'Evaluación final tras la revisión del administrador y el análisis DISC',
    },
    preScoreTab: {
      notCompleted: 'La evaluación pre-score aún no se ha completado.',
      runToSeeInsights: 'Ejecuta la evaluación pre-score para ver los insights de la IA.',
      overallScore: 'Puntuación General',
      executiveSummary: 'Resumen Ejecutivo',
      subScoresBreakdown: 'Desglose de Sub-puntuaciones',
      formula: 'Fórmula: ',
      extractedFeatures: 'Características Extraídas',
      yearsExperience: 'Años de Experiencia:',
      avgTenure: 'Antigüedad Media:',
      founderMonths: 'Meses como Fundador:',
      promotions: 'Ascensos:',
      keywordsDensity: 'Densidad de Palabras Clave:',
      activityItems: 'Elementos de Actividad:',
      keyStrengths: 'Puntos Fuertes',
      areasOfConcern: 'Áreas de Atención',
    },
    postScoreTab: {
      notCompleted: 'La evaluación post-score aún no se ha completado.',
      addNotesToTrigger: 'Añade notas del administrador y evaluación DISC para activar la evaluación post-score.',
      finalScore: 'Puntuación Final',
      finalRecommendation: 'Recomendación Final',
      executiveSummaryUpdated: 'Resumen Ejecutivo (Actualizado)',
      keyStrengthsFinal: 'Puntos Fuertes (Evaluación Final)',
      areasOfConcernFinal: 'Áreas de Atención (Evaluación Final)',
      finalReasoning: 'Razonamiento Final',
      nextSteps: 'Próximos Pasos',
      adminNotesAddressed: 'Notas del Administrador Atendidas',
      personalityTraits: 'Rasgos de Personalidad:',
      appearanceAssessment: 'Evaluación de la Apariencia:',
      preScoreConsideration: 'Consideración del Pre-Score:',
    },
  },

  applicationProfilePage: {
    title: 'Perfil de Solicitud',
    noHeadline: 'Sin titular proporcionado',
    linkedinProfile: 'Perfil de LinkedIn',
    preScore: 'Pre-Score',
    postScore: 'Post-Score',
    preScoreSummary: 'Resumen Pre-Score',
    adminReview: {
      title: 'Revisión del Administrador',
      description: 'Notas y evaluaciones de la revisión del administrador',
    },
    discAssessment: 'Evaluación DISC',
    selectDiscType: 'Selecciona un tipo de personalidad DISC...',
    none: 'Ninguno',
    noDiscYet: 'Aún no se ha añadido una evaluación DISC. Haz clic en Editar para añadirla.',
    adminNotes: 'Notas del Administrador',
    noNotesYet: 'Aún no se han añadido notas del administrador. Haz clic en Editar para añadirlas.',
  },

  entrepreneurProfilePageNew: {
    breadcrumbEntrepreneurs: 'emprendedores',
    breadcrumbProfile: 'perfil',
    entrepreneurFallback: 'Emprendedor',
    present: 'Actualidad',
    viewApplication: 'Ver Solicitud',
    about: 'Sobre mí',
    experience: 'Experiencia',
    current: 'Actual',
    education: 'Educación',
    skills: 'Habilidades',
    languages: 'Idiomas',
    certifications: 'Certificaciones',
    view: 'Ver',
    created: 'Creado {{time}}',
    updated: 'Actualizado {{time}}',
  },

  adminDashboard: {
    title: 'Panel de Administración',
    welcomeBack: 'Bienvenido de nuevo, {{name}}',
    refresh: 'Actualizar',
    signOut: 'Cerrar Sesión',
    signingOut: 'Cerrando sesión...',
    stats: {
      pendingApplications: 'Solicitudes Pendientes',
      awaitingReview: 'Esperando revisión',
      adminUser: 'Usuario Administrador',
      administrator: 'Administrador',
      status: 'Estado',
      online: 'En línea',
      systemOperational: 'Sistema operativo',
    },
    pendingSection: {
      title: 'Solicitudes de Emprendedores Pendientes',
      description: 'Revisa y aprueba o rechaza las solicitudes de emprendedores',
    },
  },

  commandPalette: {
    startTypingAll: 'Empieza a escribir para buscar',
    startTypingEntrepreneurs: 'Empieza a escribir para buscar emprendedores',
    filterByTypeHint: 'filtrar por tipo',
    searchByIdHint: 'buscar por ID',
    filterByTypeHeading: 'Filtrar por tipo',
    search: 'Buscar',
    also: 'también',
    searchByIdOrSlug: 'Buscar por ID o slug',
    enterIdOrSlugDesc: 'Introduce un UUID o slug para encontrar entidades específicas',
    typeAtLeast2: 'Escribe al menos 2 caracteres para buscar',
    searching: 'Buscando...',
    noResultsFor: 'No se encontraron resultados para "{{query}}"',
    recent: 'Recientes',
    placeholderEntrepreneurs: 'Buscar emprendedores...',
    placeholderEverything: 'Buscar en todo...',
    placeholderFiltered: 'Buscar {{types}}...',
    placeholderIdOrSlug: 'Introduce ID o slug...',
    types: {
      marketInsights: 'Market Insights',
      opportunities: 'Oportunidades',
      solutions: 'Soluciones',
      startups: 'Startups',
      projects: 'Proyectos',
      committees: 'Comités',
      entrepreneurs: 'Emprendedores',
      applications: 'Aplicaciones',
    },
  },

  emoi: {
    title: 'emoi',
    subtitle: 'asistente integrado',
    open: 'Abrir emoi',
    close: 'Cerrar emoi',
    placeholder: 'Pídele algo a emoi…',
    send: 'Enviar',
    contextLabel: 'contexto',
    pending: 'Pensando…',
    toolCall: 'acción',
    empty: 'Pídele a emoi que añada una oportunidad a este comité, o que opere Terminus sin salir de esta página.',
    errorPrefix: 'No se pudo contactar a emoi',
    clear: 'Borrar conversación',
  },
  explanations: {
    solutionScore: {
      title: 'Cómo se calcula la puntuación de la solución',
      content: `La **puntuación de la solución** es un número del **0 al 100**. No la genera directamente la IA: se calcula de forma **determinista** en el servidor como la suma de seis dimensiones ponderadas.

| Dimensión | Máx. | Qué mide |
|---|---|---|
| Encaje con la línea | 30 | Encaje con la línea de solución y su KPI |
| Encaje del startup | 30 | Coincidencia de producto, tecnología y modelo de negocio |
| Viabilidad de datos | 15 | Disponibilidad y viabilidad de TI de los datos necesarios |
| TTV / retorno | 10 | Tiempo de generación de valor ≤ 90 días y retorno ≤ 12 meses |
| Transferibilidad | 5 | Potencial de reutilización en otras líneas |
| Modelo de negocio / ICP | 10 | Encaje de precio y operación con el perfil de cliente ideal |

Cada dimensión se puntúa hasta su máximo y luego se suman las seis para obtener la puntuación final sobre 100. Una puntuación más alta indica una solución más sólida y viable.`,
    },
    startupMatch: {
      title: 'Cómo se calcula la puntuación de encaje del startup',
      content: `La puntuación de **encaje del startup** es un número del **0 al 100** que mide cómo de bien encaja un startup con esta solución concreta. Es una media ponderada fija de tres dimensiones, cada una valorada de 0 a 10 por la IA frente a la solución y luego escalada a 0–100.

| Dimensión | Peso | Qué mide |
|---|---|---|
| Encaje con el problema | 45% | Cómo de bien aborda el startup el problema de la oportunidad |
| Encaje con la solución | 45% | Cómo de bien encaja la tecnología del startup con la solución |
| Transferibilidad | 10% | Cómo de transferible es el startup a los mercados de UE / EE. UU. |

Solo se muestran los startups que puntúan **70 o más**. Una puntuación más alta indica un encaje más sólido y transferible.`,
    },
    startupSearchRanking: {
      title: 'Cómo funciona el ranking de búsqueda de startups',
      content: `La búsqueda de startups se ejecuta íntegramente contra **PostgreSQL**, no contra la base vectorial. Una startup existe en Postgres desde el momento en que se crea, mientras que su vector en Qdrant solo aparece cuando termina la generación 2DS + one-pager — por eso buscar en Postgres es lo que hace que una startup recién creada se encuentre de inmediato.

**Dónde busca**

| Campo | Peso |
|---|---|
| nombre, nombre chino | **A** (el más alto) |
| nombre alternativo, slug | **B** |
| narrativa 2D de problema/mercado | **C** |
| narrativa 2D de negocio/ejecución, sector | **D** (el más bajo) |

Una coincidencia en el nombre supera a una encontrada solo en el cuerpo del one-pager.

**Cómo se ordenan los resultados**

1. **Coincidencia exacta de nombre** primero.
2. **El nombre empieza por tu consulta** después.
3. **Puntuación de relevancia** (\`ts_rank\`) para el resto.
4. **Actualizado más recientemente** desempata, para un orden siempre estable.

**La puntuación**

El número 0–1 de cada fila es la relevancia, normalizada respecto al mejor resultado — el primero siempre es 1.00. Las filas sin puntuación provienen de un listado por sector, no de una búsqueda ordenada.

**Notas**

- Los términos se combinan con OR y coincidencia por prefijo.
- Los nombres en chino se buscan además por subcadena, porque la tokenización de texto completo no segmenta CJK.
- El interruptor de sector filtra en el servidor; desactívalo para buscar en todos los sectores.`,
    },
    marketInsightMatch: {
      title: 'Cómo se calcula la puntuación de coincidencia del market insight',
      content: `Emparejar un market insight con startups ocurre en **dos etapas**, por eso la puntuación de arriba y las de abajo pueden verse distintas entre sí.

**1. Búsqueda semántica (por dimensión)**

El titular y el resumen del problema del market insight se vectorizan y se buscan en Qdrant contra el perfil de cada startup, en dos dimensiones independientes:

| Dimensión | Qué mide |
|---|---|
| Problema y mercado | Cuánto encaja el problema/mercado del startup con el market insight |
| Negocio y ejecución | Cuánto encaja el modelo de negocio y la ejecución del startup |

Cada dimensión conserva su mejor puntuación bruta de similitud coseno — eso es lo que se muestra por dimensión más abajo.

**2. Reordenación por IA (puntuación final)**

Los mejores candidatos de la etapa 1 se reordenan después con Cohere contra la consulta de investigación completa, generando la **puntuación de coincidencia final** que se muestra arriba, junto al nombre del startup. Este es un modelo de relevancia distinto al de la búsqueda semántica bruta, así que puede puntuar a un startup más alto o más bajo de lo que sus puntuaciones brutas por dimensión sugerirían por sí solas.

Si la reordenación no estaba disponible cuando se creó esta coincidencia, la puntuación final recurre a la puntuación semántica bruta — y para coincidencias antiguas, creadas antes de que existiera la puntuación por dimensión, abajo solo se guarda una única puntuación bruta sin diferenciar.`,
    },
  },
  fileDropzone: { validation: {"rejected":"Archivos rechazados: {{files}}.","singleFile":"Selecciona un solo archivo.","fileTooLarge":"El archivo supera el tamaño máximo de {{max_mb}} MB. Extensiones admitidas: {{allowed_extensions}}.","unsupportedFileType":"Extensión de archivo no admitida. Extensiones admitidas: {{allowed_extensions}}. Tamaño máximo: {{max_mb}} MB."} },
  gaiaDocuments: {
    loading: "Cargando documentos...",
    loadError: "No se pudieron cargar los documentos.",
    retry: "Reintentar",
    noMatches: "No hay documentos que coincidan con la búsqueda.",
    noPending: "No hay documentos pendientes de aceptación.",
    noFilteredResults: "No hay documentos con estos filtros.",
    detail: {"unavailableTitle":"Documento no disponible","unavailable":"El documento puede haberse eliminado o no está compartido contigo","loadError":"No se pudo cargar el documento.","backToDocuments":"Volver a documentos","backToProfile":"Volver a mi perfil"},
    delete: {"title":"Eliminar documento","acceptedWarning":"«{{document}}», versión {{version}}, fue aceptado por {{name}} el {{date}} (Madrid). Si lo eliminas, esa constancia de aceptación dejará de estar accesible.","error":"No se pudo eliminar el documento. Puedes reintentarlo."},
    sidebar: 'Documentos', title: 'documentos', subtitle: 'Documentación compartida con personas y proyectos de gaia.',
    itemType: 'documento', search: 'Buscar documento, persona, email o proyecto...', perPage: 'Documentos por página:', empty: 'Todavía no hay documentos en tu ámbito.',
    stats: { total: 'Total', pending: 'Pendientes', accepted: 'Aceptados' },
    status: { no_acceptor: 'Sin aceptante', pending: 'Pendiente de aceptación', accepted: 'Aceptado' },
    target: { all: 'Todos los destinos', user: 'Persona', project: 'Proyecto' },
    category: { all: 'Todas las categorías', contract: 'Contrato', support_material: 'Material de apoyo', other: 'Otro' },
    filter: { no_acceptor: 'Sin aceptante', all: 'Cualquier aceptación', pending: 'Pendientes de aceptación', accepted: 'Aceptados', not_required: 'Sin aceptación' },
    uploader: { all: 'Cualquier persona que subió' },
    sort: { newest: 'Más recientes', oldest: 'Más antiguos', name_asc: 'Nombre A–Z', name_desc: 'Nombre Z–A' },
    actions: { view: 'Ver', download: 'Descargar', newVersion: 'Nueva versión', reassign: 'Reasignar', history: 'Historial' },
    fields: { target: 'Destino', selectTarget: 'Seleccionar persona o proyecto', file: 'Archivo', name: 'Nombre', category: 'Categoría', description: 'Descripción', requiresAcceptance: 'Requiere aceptación expresa del usuario', requiresAcceptanceHint: 'La persona destinataria o el primer participante del proyecto deberá confirmarlo.' },
    upload: { title: 'Subir documento', action: 'Subir documento', submit: 'Guardar documento', error: 'No se pudo subir el documento.' },
    fileDropzone: { dropActive: 'Suelta el archivo aquí', dropIdle: 'Arrastra y suelta el archivo aquí', browse: 'o selecciónalo en tu equipo', formats: 'Formatos admitidos', files: 'Archivos', remove: 'Quitar archivo' },
    targetPicker: { loadError: 'No se pudieron cargar los destinos.', title: 'Seleccionar destino', description: 'Solo aparecen personas y proyectos dentro de tu ámbito.', search: 'Buscar persona o proyecto...', empty: 'No hay destinos disponibles.' },
    version: { title: 'Subir nueva versión', submit: 'Guardar nueva versión', confirmTitle: 'Confirmar nueva versión', confirm: 'Subir e invalidar aceptación', invalidationWarning: 'La versión actual fue aceptada por {{name}} el {{date}}. Esa aceptación quedará invalidada y el documento volverá a quedar pendiente de aceptación.' },
    reassign: { title: 'Reasignar documento', description: 'La reasignación no crea una versión nueva.', current: 'Destino actual', select: 'Seleccionar nuevo destino' },
    history: { timezone: 'Madrid', downloadVersion: 'Descargar versión {{version}}', noEvents: 'Todavía no hay actividad.', noVersions: 'Todavía no hay versiones.', title: 'Historial del documento', versions: 'Versiones', events: 'Actividad', system: 'Sistema' },
    event: { created: 'Documento creado', assigned: 'Documento asignado', accepted: 'Documento aceptado', acceptance_invalidated: 'Aceptación anterior invalidada', version_uploaded: 'Nueva versión subida', reassigned: 'Destino reasignado', deleted: 'Documento eliminado' },
    project: { title: 'Documentos', description: 'Material y documentación asignada a este proyecto.', empty: 'Este proyecto todavía no tiene documentos.' },
    profile: { userTitle: 'Documentos', userEmpty: 'No hay documentos dirigidos a esta persona que puedas ver.', selfEmpty: 'Todavía no se han compartido documentos contigo.' },
    preview: { unavailable: 'Este formato no se puede previsualizar dentro de gaia. Descarga el archivo para revisar su contenido.' },
    accept: { versionChanged: 'El documento ha cambiado de versión. Revisa la versión actual y vuelve a confirmar su aceptación.', error: 'No se pudo aceptar el documento.', noAcceptor: 'No hay participantes activos que puedan aceptar este documento. Sigue pendiente y puede reasignarse.', acceptedBy: 'Aceptado por {{name}}', checkbox: 'He leído y acepto expresamente el contenido de este documento', action: 'Aceptar documento', confirmTitle: 'Confirmar aceptación', confirmDescription: 'Vas a aceptar «{{name}}», versión {{version}}. Esta aceptación expresa quedará registrada en el historial.', confirm: 'Confirmar aceptación' },
  },
  clients: {
    list: {
      title: 'Clientes',
      subtitle: 'Empresas cliente con las que trabaja tu organización',
      newClient: 'Nuevo Cliente',
      searchPlaceholder: 'Buscar clientes...',
      count_one: '{{count}} cliente',
      count_other: '{{count}} clientes',
      empty: 'Aún no hay clientes',
      errorLoading: 'Error al cargar clientes: {{message}}',
      sectorFilter: 'Sector',
      clearFilters: 'Limpiar filtros',
    },
    form: {
      title_create: 'Nuevo Cliente',
      title_edit: 'Editar Cliente',
      company: 'Empresa',
      company_placeholder: 'Nombre de la empresa',
      industry: 'Industria',
      industry_placeholder: 'Selecciona una industria',
      web: 'Sitio web',
      web_placeholder: 'https://ejemplo.com',
      contact_name: 'Nombre de contacto',
      contact_name_placeholder: 'Nombre de contacto',
      contact_role: 'Rol',
      contact_role_placeholder: 'Rol del contacto',
      contact_email: 'Email de contacto',
      contact_email_placeholder: 'contacto@ejemplo.com',
      contact_phone: 'Teléfono de contacto',
      contact_phone_placeholder: 'Número de teléfono de contacto',
    },
    detail: {
      itemType: 'cliente',
    },
    project: {
      title: 'clientes',
      empty: 'No hay clientes vinculados a este proyecto.',
      addClient: 'Añadir cliente',
      detach: 'Desvincular',
      attachedCount_one: '{{count}} cliente vinculado',
      attachedCount_other: '{{count}} clientes vinculados',
      attachFailed: 'No se pudo vincular el cliente',
      picker: {
        title: 'Vincular cliente',
        description: 'Busca un cliente existente o crea uno nuevo para vincularlo a este proyecto.',
        searchPlaceholder: 'Buscar clientes...',
        noClients: 'Aún no hay clientes.',
        noMatches: 'Ningún cliente coincide con tu búsqueda.',
        addNew: 'Nuevo cliente',
        sectorFilterLabel: 'Filtrar por sector',
      },
    },
  },
};
